export default class Subscription {
  constructor() {
    this.clickFromChangePlanBtn = false;
    this.paymentMethod = { credit_card: 'stripe', bank: 'bank' };
    this.hasCard = false
    this.checkStatusChangePlan = false
    this.flowStack = []
    this._navHiding = {}
    const me = this
    setTimeout(function() {
      me.popupConfirmAutoSetPaymentMethodBank();
    }, 2000)

    const resetStateModals = [
      'changePlanModal',
      'changePaymentMethodModal',
      'annualPaymentModal',
      'upgradePlanPaymentModal',
      'monthlyPaymentModal',
      'handleConfirmPaymentMethodModal',
      'changePlanConfirmModal',
      'announcementSettingsConfirmModal',
      'billingInformationSettingsConfirmModal'
    ];

    resetStateModals.forEach(id => {
      $(document).on('hidden.bs.modal', `#${id}`, function() {
        if (me._navHiding[id]) { me._navHiding[id] = false; return; }
        me.resetPaymentModalState(id);
      });
    });

  }

  async checkChangePayment(ele, call_from_header=false) {
    const paymentSelected = $(ele).val()
    const currentPaymentMethod = $('#js-store_all_data_to_handle').attr('data-current-payment-method');
    const newPlanId = Number($('#input_change_membership_plan').val());
    this.data_membership_plan = JSON.parse($('#js-store_all_data_to_handle').attr('data-membership_plan') || {});
    if (paymentSelected === 'bank') {
      if ($('#plan_header_first_time_payment_method_flow')?.val() == 'true') {
        const payment_term = $('#subscriptions_payment_term').val();
        if(payment_term == 'year'){
          $('input[name="payment-term_bank"][value="year"]').prop('checked', true);
        }
      }
      const bodyPaymentEle = $(ele).parents('div.body-payment')
      await Shared.callAjax(
        Routes.check_can_payment_to_paid_owner_subscriptions_path(),
        {}
      )
      .done(function(data) {
        $('div#credit_card_info').hide();
        if (data.success) return
        bodyPaymentEle.find('input[value="stripe"]').prop('checked', true)
      })
    } else {
      $('div#credit_card_info').show();
    }
    $('input[name="payment_method"]:checked').parents('label').next().removeClass('d-none')
    $('input[name="payment_method"]:not(:checked)').parents('label').next().addClass('d-none')
    if(call_from_header) {
      const checked = $('input[name="payment_method"]:checked').val();
      const updateButton = $('#submit_change_payments_header_modal');
      updateButton.prop('disabled', !checked);
      return
    }
    if (currentPaymentMethod === $('input[name="payment_method"]:checked').val()) {
      this.render_text_with_change_plan(newPlanId, currentPaymentMethod, $('input[name="payment_method"]:checked').val())
    } else {
      this.renderTextWithChangePaymentMethod(newPlanId, $('input[name="payment_method"]:checked').val())
    }
  }

  renderTextWithChangePaymentMethod(newPlanId, paymentMethod) {
    this.data_membership_plan.push(['supplier', 0])
    let text_price_with_bank_and_month;
    let text_price_with_bank_and_year;
    let text_price_with_stripe_and_month;
    let text_price_with_stripe_and_year;
    let text_with_info_plan_and_bank_and_month;
    let text_with_info_plan_and_bank_and_year;
    let text_with_info_plan_and_stripe_and_month;
    let text_with_info_plan_and_stripe_and_year;
    let newPlan = this.data_membership_plan.filter((plan) => { return plan[0] === newPlanId })[0]
    if (newPlan[2] === 0) {
      text_price_with_bank_and_month = '※プラン選択後に金額確定'
      text_price_with_bank_and_year = '※プラン選択後に金額確定'
      text_price_with_stripe_and_month = '※プラン選択後に金額確定'
      text_price_with_stripe_and_year = '※プラン選択後に金額確定'
      let plan_name = newPlan[1]
      plan_name = I18n.t(`enums.membership_plan.name.${plan_name}`)
      text_with_info_plan_and_bank_and_month = `${plan_name} プランは決済されません。`
      text_with_info_plan_and_bank_and_year = `${plan_name} プランは決済されません。`
      text_with_info_plan_and_stripe_and_month = `${plan_name} プランは決済されません。`
      text_with_info_plan_and_stripe_and_year = `${plan_name} プランは決済されません。`
    } else {
      const price = newPlan[2]
      text_price_with_bank_and_month = `${Shared.numberToCurrency(price)}円（税別）`
      text_price_with_bank_and_year = `${Shared.numberToCurrency(price * 10)}円（税別）`
      text_price_with_stripe_and_month = `${Shared.numberToCurrency(price)}円（税別）`
      text_price_with_stripe_and_year = `${Shared.numberToCurrency(price * 10)}円（税別）`
      if (paymentMethod === 'stripe') {
        text_with_info_plan_and_bank_and_month = '申込後に決済されます。'
        text_with_info_plan_and_bank_and_year = '申込後に決済されます。'
        text_with_info_plan_and_stripe_and_month = '更新後に決済されます。'
        text_with_info_plan_and_stripe_and_year = '更新後に決済されます。'
      } else {
        text_with_info_plan_and_bank_and_month =
          `申込後のお支払い期限は${gon.contract_info.date_with_bank_and_month}です。`
        text_with_info_plan_and_bank_and_year =
          `申込後のお支払い期限は${gon.contract_info.date_with_bank_and_year}です。`
        text_with_info_plan_and_stripe_and_month = ``
        text_with_info_plan_and_stripe_and_year = ``
      }

      if (newPlan[4]) {
        text_price_with_bank_and_month = `${Shared.numberToCurrency(0)}円　※キャンペーン中`
        text_price_with_bank_and_year = `${Shared.numberToCurrency(price * 10 * (newPlan[5] / 12))}円（税別）※キャンペーン中`
        text_price_with_stripe_and_month = `${Shared.numberToCurrency(0)}円　※キャンペーン中`
        text_price_with_stripe_and_year = `${Shared.numberToCurrency(price * 10 * (newPlan[5] / 12))}円（税別）※キャンペーン中`
        text_with_info_plan_and_bank_and_month = '更新後に決済されます。'
        text_with_info_plan_and_bank_and_year += '（6ヶ月分は通常料金が決済されます）'
        text_with_info_plan_and_stripe_and_year += '（6ヶ月分は通常料金が決済されます）'
      }
    }
    $('#text_price_with_bank_and_month').html(text_price_with_bank_and_month)
    $('#text_price_with_bank_and_year').html(text_price_with_bank_and_year)
    $('#text_price_with_stripe_and_month').html(text_price_with_stripe_and_month)
    $('#text_price_with_stripe_and_year').html(text_price_with_stripe_and_year)

    $('#text_with_info_plan_and_bank_and_month').html(text_with_info_plan_and_bank_and_month)
    $('#text_with_info_plan_and_bank_and_year').html(text_with_info_plan_and_bank_and_year)
    $('#text_with_info_plan_and_stripe_and_month').html(text_with_info_plan_and_stripe_and_month)
    $('#text_with_info_plan_and_stripe_and_year').html(text_with_info_plan_and_stripe_and_year)
  }

  requestRegisterPaid() {
    Shared.callAjax(
      Routes.register_member_paid_owner_subscriptions_path(),
      {}
    )
    .done(function(data) {
      if (data.register) {
        Popup.alert('銀行振込申請を行いました。')
        Shared.reloadPage()
      } else {
        Popup.alert(data.message)
      }
    })
    .fail(function(data) {
      if (data.responseJSON.message) Popup.alert(data.responseJSON.message)
      if (data.responseJSON.is_show_update_company_infor) {
        checkZipCode()
        $('#applicationBankTransferForm').modal('show')
      }
    })
  }

  handleTeamNameChange(input) {
    const updateButton = $('.update-team-name-btn');
    if (input && input.value && input.value.trim() !== '') {
      updateButton.prop('disabled', false);
    } else {
      updateButton.prop('disabled', true);
    }
  }

  handleUpdateTeamName() {
    const teamNameInput = $('.team-name-input input');
    const teamName = teamNameInput.val().trim();
    
    Shared.callAjax('/company/info/update_company_name',
      {
        name: teamName
      }
    )
    .done(function(data) {
      $('.team-name p b').text(`現在のチーム名：${teamName}`);
      teamNameInput.val('');
      Popup.alert('チーム名が正常に更新されました。');
    })
    .fail(function(error) {
      Popup.alert(error.responseJSON.error);
    });
  }
  
  checkFiledKatakana(ele, is_error) {
    let regex_katakana_name = /^[ァ-・ヽヾ゛゜ー ( )（）]+$/;
    if (!regex_katakana_name.test($(ele).val())) {
      $(ele).addClass('is-invalid').parent().css('border', '2px solid red');
      is_error = false
    } else {
      $(ele).removeClass('is-invalid').parent().css('border', '2px solid #4384b4');
    }
  }

  async handleSubmitUpdateInfo(event, authPassword=null, modal_id=null) {
    let isSubmit = true;

    if (
      (!$('#subscriptions_payment_term').val() &&
       gon.membership_plan.paid_ids.includes(Number($('#subscriptions_membership_plan_id').val()))
      ) || !$('#subscriptions_membership_plan_id').val()
       ) {
      $('#js-will_change_subscription_to').html('プランと支払周期を入力してください。')
      isSubmit = false;
    }
    if (!$('#subscriptions_payment_method').val() &&
        gon.membership_plan.paid_ids.includes(Number($('#subscriptions_membership_plan_id').val()))) {
      $('#js-will_change_payment_to').html('支払方法を入力してください。')
      isSubmit = false;
    }

    if ($('#js-will_change_credit_card_to').attr('data-customer-id') == 'false') {
      if ($('#subscriptions_payment_method').val() == 'stripe') {
        if ($('#subscriptions_credit_card').val() == '' || $('#subscriptions_credit_card').val() == undefined) {
          $('#js-will_change_credit_card_to').html('クレジットカード決算で支払方法を選択されましたので、<br/>クレジットカード情報を入力してください。');
          isSubmit = false
        } else {
          $('#js-will_change_credit_card_to').html('')
        }
      } else {
        $('#js-will_change_credit_card_to').html('')
      }
    }

    if ($('#subscriptions_payment_method').val() == 'bank') {
      if (!$('input.js-subscription_company_infor_invoice').toArray().every(function(ele) { return !!$(ele).val() })) {
        $('#company_infor_invoice_not_empty').addClass('text-danger-new')
          .html('銀行振込で支払方法が選択されましたので、<br/>銀行振込情報を入力してください。');
        isSubmit = false
      } else {
        $('#company_infor_invoice_not_empty').html('')
      }
    } else {
      $('#company_infor_invoice_not_empty').html('')
    }

    if($(".submit-subscription-update-info").data("can-submit") == "cannot") {
      isSubmit = false
      $("#remindCheckCode").modal("show")
    }

    if($(".submit-subscription-update-info").data("price_valid") == "invalid") {
      isSubmit = false
      Popup.alert($(".submit-subscription-update-info").data('error_message'));
    }

    event.preventDefault();
    if (isSubmit) {
      const newPlan = Number($('#input_change_membership_plan').val());
      const paymentMethod = $('input[name="payment_method"]:checked').val()
      const paymentTerm = $(`input[name="payment-term_${paymentMethod}"]:checked`).val()
      const creditCard = $('#number_credit_card').val()
      const password = authPassword || $('#subscriptions_password_input').val()
      const nameCreditCard = $('#name_credit_card').val()
      const paramsCard = creditCard.slice(creditCard.length - 4, creditCard.length)
      let data = await this.handleCheckChangePlan(newPlan, paymentTerm, paramsCard, password, paymentMethod, nameCreditCard)
      $('#subscriptions_password_input').val(password)
      if (data.no_card) {
        this._handleNoCard()
      } else if (data.upgrade_from_supplier_plan) {
        this._upgradeFromSupplierPlan(data.current_plan_akapon)
      } else if (data.not_change_plan) {
        this.handleShowPopupLatePayment(data.invoice_delay, 'not_change', null)
      } else if (data.lack_of_information) {
        this.handleShowPopupLackOfInfo();
      } else if (data.password_incorrect && authPassword && modal_id) {
        $(`#${modal_id}`).find('#payment-password-instruction').addClass('d-none');
        $(`#${modal_id}`).find('#wrong-password').removeClass('d-none');
      } else if (data.password_incorrect && !authPassword) {
        $('#wrongPasswordAlert').find('p').html('現在のパスワードが間違っています。')
        $('#wrongPasswordAlert').modal('show');
      } else if (data.connect_error) {
        Popup.alert(I18n.t('shared.one_error_please_try_again'))
      } else {
        if (modal_id) {
          $(`#${modal_id}`).find('#payment-password-instruction').removeClass('d-none');
          $(`#${modal_id}`).find('#wrong-password').addClass('d-none');
        }
        this.submitUpdateContractInfo()
      }
    }
  }

  async handleCheckChangePlan(newPlanId, paymentTerm, credit_card, password, paymentMethod, nameCreditCard) {
    let data;
    await Shared.callAjax(
      Routes.handle_check_change_plan_owner_subscriptions_path(),
      {
        new_plan_id: newPlanId,
        payment_term: paymentTerm,
        credit_card: credit_card,
        password: password,
        payment_method: paymentMethod,
        credit_card_name: nameCreditCard,
        cancel_subscription: $('input#subscriptions_cancel_subscription').val(),
        campaign_code: $('input#campaign_code').val()
      }
    )
    .done(function(respond) {
      data = respond
    })
    .fail(function(respond) {
      data = respond
    })
    return data
  }

  async handleCheckPassword(password) {
    let data;
    await Shared.callAjax(
      Routes.handle_check_password_owner_subscriptions_path(),
      {
        password: password
      }
    )
    .done(function(respond) {
      data = respond
    })
    .fail(function(respond) {
      data = respond
    })  
    return data
  }

  fetchTextWithUpgradePlan(paymentMethod, data, textWithPaymentTerm, textWithPaymentMethod) {
    let amountText;
    let confirmText;
    let classCol = Shared.screenMobile() ? '' : 'col-3'
    if (data.discount_amount > 0) {
      amountText = `<span class="${classCol} p-0">差額決済額</span><span class="">：${Shared.numberToCurrency(data.amount)}円（税込）</span>
      <span class="${classCol} p-0">値引き額</span><span class="">：${Shared.numberToCurrency(data.discount_amount)}円 （対象割引率${data.discount_value}％）</span>
      <span class="${classCol} p-0">請求金額</span><span class="">：${Shared.numberToCurrency(data.amount_after_discount)}円（税込）</span>`
    } else {
      amountText = `<span class="${classCol} p-0">請求金額</span><span class="">：${Shared.numberToCurrency(data.amount)}円（税込）</span>`
    }
    if (data.upgrade_form_akapon_to_cc_plan) {
      confirmText = `アカポン会員からCreate Cloud会員へ変更します。
      変更後、アカポン会員へは戻れなくなります。
     上記の内容で更新してよろしいですか？`
    } else {
      confirmText = '上記の内容で契約情報を更新してよろしいですか？'
    }

    let number_default_card = $('#js-number-default-card').val();
    let name_default_card = $('#js-name-default-card').val();
    if (data.is_promotion) {
      amountText += `<br><span class="${classCol} p-0">値引額</span><span class="">：${Shared.numberToCurrency(data.promotion_price)}円（税込）※キャンペーン中</span>
      <span class="${classCol} p-0 font-weight-bold">値引後請求金額</span><span class="font-weight-bold">：${Shared.numberToCurrency(data.amount - data.promotion_price)}円</span>`
    }

    if (paymentMethod == 'stripe') {
      return `<div class="text-center h5 font-weight-normal mt-n5 ml-3 ${Shared.screenMobile() ? 'mb-n4' : 'mb-n5'}">
          <p class="rows text-left ${Shared.screenMobile() ? '' : 'pl-3'}" style="${Shared.screenMobile() ? '' : 'padding-left: 32% !important;'}">
          <span class="${classCol} p-0">プラン</span><span class="">：${data.plan_name}</span>
          ${amountText}
          <span class="${classCol} p-0">支払方法</span><span class="">：${textWithPaymentMethod} | ${textWithPaymentTerm}</span>
          <span class="${classCol} p-0">対象期間</span><span class="">：${data.time_line}</span>
          <span class="${classCol} p-0">クレジットカード情報</span><span class="">：${number_default_card ? `****${number_default_card}` : data.credit_card}</span>
          <span class="${classCol} p-0">クレジットカード名義名</span><span class="">：${name_default_card ? name_default_card : data.card_name}</span>
          ${
            !!data.next_payment_date_of_promotion ?
            `<span class="${classCol} p-0">次回請求日</span><span class="">：${I18n.l('date.formats.ja', data.next_payment_date_of_promotion)}</span>` :
            `<span class="${classCol} p-0">${data.upgrade_paid_plan ? '差額決済日' : '請求日'}</span><span class="">：${I18n.l('date.formats.ja', gon.date_current)}</span>`
          }
        </p>
        <span class="text-center d-block">${confirmText}</span>
      </div>
      `
    } else {
      let invoiceDate = new Date(gon.date_current);
      if (!data.upgrade_paid_plan) {
        invoiceDate.setMonth(invoiceDate.getMonth() + 1);
        invoiceDate.setDate(1);
      }
      return `<div class="text-center h5 font-weight-normal mt-n5 ml-3 ${Shared.screenMobile() ? 'mb-n4' : 'mb-n5'}">
          <p class="rows text-left ${Shared.screenMobile() ? '' : 'pl-3'}" style="${Shared.screenMobile() ? '' : 'padding-left: 32% !important;'}">
          <span class="${classCol} p-0">プラン</span><span class="">：${data.plan_name}</span>
          ${amountText}
          <span class="${classCol} p-0">支払方法</span><span class="">：${textWithPaymentMethod} | ${textWithPaymentTerm}</span>
          <span class="${classCol} p-0">対象期間</span><span class="">：${data.time_line}</span>
          ${
            !!data.next_payment_date_of_promotion ?
            `<span class="${classCol} p-0">次回請求日</span><span class="">：${I18n.l('date.formats.ja', data.next_payment_date_of_promotion)}</span>` :
            `<span class="${classCol} p-0">${data.upgrade_paid_plan ? '差額決済日' : '請求日'}</span><span class="">：${I18n.l('date.formats.ja', invoiceDate)}</span>`
          }
        </p>
        <span class="text-center d-block">${confirmText}</span>
      </div>
      `
    }
  }

  handleShowPopupLackOfInfo() {
    Popup.confirm(`<div class="fs-20 font-weight-bold line-height-1-6">未入力のアカウント情報があります。</div>※Create Cloudプランでは、住所などのアカウント情報が必須となります。`, {
      success: () => {
        $('#companyProfileModal').modal('show')
      },
      cancel: () => {},
      confirmText: 'アカウント情報を更新する',
      cancelBtn: 'false',
      width: 'auto'
    })
  }

  updateProfile(event) {
    event.preventDefault();
    ProfilePage.validate(event, $(event.target).parents('form'))
  }

  async handleShowPopupUpgrade(data) {
    const paymentMethod = $('#subscriptions_payment_method').val()
    const paymentTerm = $(`input[name="payment-term_${paymentMethod}"]:checked`).val()
    const textWithPaymentTerm = paymentTerm == 'month' ? '月払' : '年払'
    const textWithPaymentMethod = paymentMethod == 'bank' ? '銀行振込' : 'クレジットカード決済'
    if (data.is_error_data) {
      Popup.alert(
        I18n.t('subscription.message_downgrade_error_data', {
          data_size: data.detail_error.max_data, next_plan: data.detail_error.new_plan_name
        }),
      )
      return
    }

    await Popup.confirm(
      this.fetchTextWithUpgradePlan(paymentMethod, data, textWithPaymentTerm, textWithPaymentMethod),
      {
        success: () => { this.submitUpdateContractInfo() },
        cancel: () => {},
        confirmText: 'OK',
        cancelBtn: 'false',
        width: '35rem'
      }
    )
  }

  async handleShowPopupLatePayment(data, action, payload) {
    if (!data) {
      this._handleShowPopupConfirmChangePlan(action, payload)
      return;
    }

    if (data.no_card) {
      this._handleNoCard()
      return;
    }

    const last4Card = $('#number_credit_card').val().slice(-4);
    await Popup.confirm(
      `<div class="text-center h5 font-weight-normal mt-n5 mb-n5 ml-3">
          <p>
          請求金額：${data.amount_to_currency}（税込）
          支払方法：${data.payment_method_text}
          対象期間：${data.period_date}
          クレジットカード情報：${!!last4Card ? `****${last4Card}` : data.last4_card}
          決済日：${I18n.l('date.formats.ja', gon.date_current)}
        </p>
        <span class="text-center d-block">上記の内容で契約情報を更新してよろしいですか？</span>
      </div>
      `,
      {
        success: () => {
          this._handleShowPopupConfirmChangePlan(action, payload)
        },
        cancel: () => {},
        confirmText: 'OK',
        cancelBtn: 'false',
        width: '35rem'
      }
    )
  }

  _upgradeFromSupplierPlan(is_akapon) {
    let planName = is_akapon ? `アカポン | FreeプランからCreate Cloud | Free` : '仕入先プランからFree'
    let confirmText;
    if (is_akapon) {
      confirmText = `<br>アカポン会員からCreate Cloud会員へ変更します。
      変更後、アカポン会員へは戻れなくなります。
     上記の内容で更新してよろしいですか？`
    } else {
      confirmText = '契約情報を更新してよろしいですか？'
    }
    Popup.confirm(
      `
        ${planName}プランへアップグレードします。
        ${confirmText}
      `,
      {
        success: () => {
          this.submitUpdateContractInfo()
        },
        cancel: () => {},
        confirmText: 'OK',
        cancelBtn: 'false',
        width: 'auto'
      }
    )
  }

  _handleShowPopupConfirmChangePlan(action, payload) {
    if (action === 'upgrade') {
      this.handleShowPopupUpgrade(payload)
    } else if (action === 'downgrade') {
      this.handleShowPopupDowngrade(payload)
    } else if (action === 'not_change') {
      this.submitUpdateContractInfo()
    }
  }

  handleShowPopupDowngrade(data) {
    if (!data.is_error) { this._showPopupConfirmDowngrade(data.detail_error); return }
    if ((data.detail_error.is_error_project && data.detail_error.is_error_data)) {
      const modalShow = $('#modal-error-downgrade-all')
      modalShow.find('.number-project-error').text(`${data.detail_error.exceed_project}個`)
      modalShow.find('.number-data-error').text(`${data.detail_error.exceed_data}`)
      modalShow.modal('show');
    } else if (data.detail_error.is_error_project) {
      const modalProject = $('#modal-error-downgrade-project')
      modalProject.find('.number-project-error').text(`${data.detail_error.exceed_project}個`)
      modalProject.modal('show');
    } else if (data.detail_error.is_error_task) {
      Popup.alert(
        I18n.t('subscription.message_downgrade_error_task', {
          project_size: data.detail_error.max_task, next_plan: data.detail_error.new_plan_name
        }),
      )
    } else if (data.detail_error.is_error_data) {
      const modalData = $('#modal-error-downgrade-data')
      modalData.find('.number-data-error').text(`${data.detail_error.exceed_data}`)
      modalData.modal('show');
    }
  }

  submitUpdateContractInfo(latePayment = false) {
    const me = this;
    if ($('#card_ids_temp_added').length != 0) {
      $('input#subscriptions_card_ids_will_added').val($('#card_ids_temp_added').val());
    }
    $('body').attr('data-has-changed', 'false');

    const formData = $('form#form_subscription_update_info').serialize();
    const ajaxCall = Shared.callAjax($('form#form_subscription_update_info').attr('action'), formData)
    ajaxCall.done(function(result) {
      if (result.success) {
        const message = latePayment ? 'クレジットカード決済が完了しました。' : '契約情報を更新しました。'
        if (result.client_secret) {
          me._showPopupNotifyVerifyPayment(result.client_secret)
        } else {
          if (result.show_popup_introduce_cc) {
            Popup.confirm(`
              <div class="text-center popup-intro-akapon-member"><div style="font-size: 24px; margin-bottom: 4px;">Create Cloudプランに変更されました。</div>Create Cloud機能をご利用頂けます。
              <div class="text-left" style="margin-left: 100px; font-size: 22px">
              ・複数プロジェクトの作成
              ・チケット管理
              ・見積書・注文・個数管理
              ・請求書・支払書管理
              ・赤入れ機能
              ・契約書作成・締結機能　など</div>
              <div style="font-size: 24px">※詳しくは<a href="https://createcloud.jp/support/" target="_blank" class="text-underline-hover">サポート</a>をご覧ください。</div></div>`, {
              cancelBtn: 'false', confirmText: 'OK',
              success: () => {
                window.location.href = Routes.owner_total_info_path()
              }
            })
            $(".popup-intro-akapon-member").parent().parent().css("border", "5px solid #2467B6")
          } else if (result.cancel_supscription) {
            Popup.confirm(message, {
              cancelBtn: 'false', confirmText: 'OK',
              success: () => {
                window.location.href = Shared.lpSite()
              }
            })
          } else if (result.show_popup_success){
            const response = result.show_popup_success
            let successMessage = '';
            if (response.change_subscription) {
              successMessage += `
                <p>・${response.payment_method == 'stripe' ? 'クレジットカード' : '銀行振込'}決済（${response.amount}）が完了しました。</p>
                <p>・${response.current_plan}プラン（${response.current_payment_term == 'year' ? '年' : '月'}払い）から${response.new_plan}プラン（${response.new_payment_term == 'year' ? '年' : '月'}払い）に変更されました。</p>
                <p>※次回決済日は「${response.next_charge_date}」になります。</p>
              `;
            }
            if (response.change_main_admin) {
              successMessage += `
                <p>・メイン管理者を更新しました。</p>
              `;
            }
            if (response.change_payment_method) {
              successMessage += `
                <p>※支払方法が${response.payment_method == 'stripe' ? 'クレジットカード' : '銀行振込'}決済に変更されました。</p>
              `;
            }
            if (response.change_notification) {
              successMessage += `
                <p>・お知らせ通知が${response.change_notification_text}に変更されました。</p>
              `;
            }
            if (response.change_invoice_infor) {
              successMessage += `
                <p>・請求先情報を更新しました。</p>
              `;
            }
            $('#changePlanConfirmModal').modal('hide');
            $('.modal').modal('hide');
            $('#changePaymentModalSuccess').modal('show');
            $('#changePaymentModalSuccess').find('#success-message-body').html(successMessage);
          } else {
            Popup.confirm(message, {
              cancelBtn: 'false', confirmText: 'OK',
              success: () => {
                if(result.cancel_supscription){
                  window.location.href = Shared.lpSite()
                } else {
                  window.location.href = Routes.owner_total_info_path()
                }
              }
            })
          }
        }
      } else {
        const pagymentMethod = $('#subscriptions_payment_method').val()
        let planName = '';
        let data_membership_plan = $('#js-store_all_data_to_handle').attr('data-membership_plan');
        let current_membership = Number($('#js-btn_show_modal_confirm_change_subscription').attr('data-current-member-plan-id'));
        let new_membership = Number($('#input_change_membership_plan').val())
        if (data_membership_plan) {
          data_membership_plan = JSON.parse(data_membership_plan);
        }

        if(data_membership_plan) {
          if(current_membership != new_membership) {
            planName = data_membership_plan.filter((plan) => { return plan[0] === new_membership })[0][1]
          } else {
            planName = data_membership_plan.filter((plan) => { return plan[0] === current_membership })[0][1]
          }
        }

        let message = pagymentMethod === 'bank' ? `${I18n.t(`enums.membership_plan.name.${planName}`)}プランは銀行振込決済をご利用できません。<br>「支払方法」よりクレジットカードの選択及びご登録をお願い致します。` : `現在の支払方法で決済できませんでした。<br>恐れ入りますが、別のクレジットカードをご利用ください。<br><br>[ERR: ${result.message}]`
        if (result.message == '限度額をオーバーしています') {
          message = `ご決済予定の金額が、<a href="https://paid.jp/v/contents/pre/buyer/" class="text-underline text-white" target="_blank">Paid</a>のご利用可能額をオーバーした為<br>${I18n.t(`enums.membership_plan.name.${planName}`)}プランのご決済ができませんした。<br>※ご利用可能額については、<a href="https://akapon.kanritools.com/contact_us" class="text-underline text-white" target="_blank">弊社へお問合わせ</a>頂くか<br><a href="https://paid.jp/v/do/member/inquiry/form" class="text-underline text-white" target="_blank">Paid管理画面</a>より、お問合わせください。`
        }
        Popup.confirm(message, {
          cancelBtn: 'false', confirmText: 'OK',
          success: () => {
            $('#CreditCard').modal('show')
          },
          width: 'auto'
        })
      }
    })
  }

  _showPopupNotifyVerifyPayment(client_secret) {
    const message = `
      契約情報更新の仮登録が完了しました。

      ご登録のメールアドレス宛にクレジットカード会社から
      決済についての連絡メールが届きます。
      承認が完了したあと、契約情報が更新されます。
    `
    Popup.confirm(message, {
      cancelBtn: 'false', confirmText: 'OK',
      success: () => {
        setTimeout(function() { Shared.loadingIndicator() }, 50)
        const stripe = Stripe(gon.stripe_publishable_key);
        stripe.confirmCardPayment(client_secret);
        setTimeout(function() { $('.preloader').fadeOut() }, 2000);
      },
      width: 'auto'
    })
  }

  _handleNoCard() {
    Popup.alert('カードがありません。<br>カードを追加してください。')
    $('#CreditCard').modal('show')
  }

  _showPopupConfirmDowngrade(data) {
    let confirmText;
    if (data.upgrade_form_akapon_to_cc_plan) {
      confirmText = `<br><br>アカポン会員からCreate Cloud会員へ変更します。<br>
      変更後、アカポン会員へは戻れなくなります。 <br>
     上記の内容で更新してよろしいですか？`
    } else {
      confirmText = '<br>契約情報を更新してよろしいですか？'
    }
    Popup.confirm('',{
      description:
        `${I18n.t('subscription.message_downgrade',
            {
              day_remaining: data.day_remaining, new_plan: data.new_plan_name,
              current_plan: data.current_plan_name
            }
          )
        } ${confirmText}`,
      success: () => { this.submitUpdateContractInfo() },
      cancel: () => {},
      confirmText: 'OK',
      // cancelBtn: 'false',
      width: 'auto'
    })
  }

  handleShowChangePlanModal(ele, call_from_link=false) {
    $('#js-submit_credit_card').attr('from-modal', '')
    if (gon.contract_info.company_status === 'payment_delayed') {
      Popup.confirm('入金遅延があるため、プランを変更できません。<br>支払方法を変更してください。', {
        success: () => {
          this._showAddCardOrChangePlan()
        },
        cancel: () => { this._showAddCardOrChangePlan() },
        confirmText: 'OK',
        cancelBtn: 'false',
        width: 'auto'
      })
      return
    }
    if (gon.contract_info.company_status !== 'payment_delayed') {
      Shared.showModalForElement('#changePlanAndPaymentTermModal')
    }
  }

  showNoPermissionModal(ele) {
    Popup.alert('管理者のみ変更可能です。')
  }

  handleShowChangePaymentMethodModal(ele) {
    $('#changePaymentMethodModal').modal('show')
  }

  handleShowCancelSubscriptionModal(ele) {
    Shared.callAjax('/company/info/statistics', {}, 'json', 'GET').done(function(result) {
      // Update statistics in the modal
      $('#stats_project_count').text(result.project_count)
      $('#stats_task_count').text(result.task_count)
      $('#stats_ticket_count').text(result.ticket_count)
      $('#stats_akaire_file_count').text(result.akaire_file_count)
      $('#stats_member_count').text(result.member_count)
      $('#stats_external_member_count').text(result.external_member_count)
      const cancellationImg = $('.cancellation_img');
      const passwordInput = $('.password-input');
      cancellationImg.removeClass('d-none');
      passwordInput.addClass('d-none');
      $('#company-password-title').html('「現在のパスワード」を入力してください。')
      // Show the modal
      $('#cancelSubscriptionModal').modal('show')
    }).fail(function(error) {
      Popup.alert(error.responseJSON.message)
    })
  }

  handleCancelButtonClick(event) {
    event.preventDefault();
    const cancellationImg = $('.cancellation_img');
    const passwordInput = $('.password-input');
    const companyPasswordTitle = $('#company-password-title');
    companyPasswordTitle.removeClass('text-red');
    companyPasswordTitle.addClass('text-black');
    if (passwordInput.hasClass('d-none')) {
      cancellationImg.addClass('d-none');
      passwordInput.removeClass('d-none');
      return;
    }
    this.handleShowCancelSubscriptionModalSubmit(event);
  }

  async handleShowCancelSubscriptionModalSubmit(event) {
    event.preventDefault();
    let isSubmit = true;
    if ($('#cancel_payment_password').val() == '' || $('#cancel_payment_password').val() == undefined) {
      isSubmit = false
      $('#company-password-title').html('登録されているパスワードが違います。<br/>再度、正しいパスワードを入力してください。<br/><a href="#" onclick="Subscription.handleShowChangePasswordModal(event)" class="text-underline text-black">パスワードをお忘れです？</a>')
    }
    if (isSubmit) {
      const password = $('#cancel_payment_password').val()
      let data = await this.handleCheckPassword(password)
      if(data.success){
        $('#company-password-title').removeClass('text-red');
        $('#company-password-title').addClass('text-black');
        $('#company-password-title').html('「現在のパスワード」を入力してください。')
        this.handleCancelCompany(true)
      } else {
        $('#company-password-title').removeClass('text-black');
        $('#company-password-title').addClass('text-red');
        $('#company-password-title').html('登録されているパスワードが違います。<br/>再度、正しいパスワードを入力してください。<br/><a href="#" onclick="Subscription.handleShowChangePasswordModal(event)" class="text-underline text-black">パスワードをお忘れです？</a>')
      }
    }
  }
  async handleCancelCompany(new_modal=false) {
    const me = this;
    if (gon.contract_info.company_status === 'payment_delayed') {
      this.showPopupWarningWhenPaymentDelayed();
    } else {
      await Shared.callAjax(Routes.check_cancel_company_owner_subscriptions_path()).done(function(result) {
        if(new_modal) {
          me.cancelCompanySubscription();
        } else {
          const modal = $('#exampleModalCenter1')
          modal.find('#btn-cancel-subscription-step1')[0]
            .setAttribute('data-object-unpaid-payment', JSON.stringify(result.in_progress))
          modal.modal('show')
        }
      })
    }
  }
  async cancelCompanySubscription(){
    await Shared.callAjax(Routes.cancel_company_owner_subscriptions_path()).done(function(result) {
      $('#cancel_company_success').removeClass('d-none');
      $('#cancel_company_modal_content').addClass('d-none');
      Shared.loadingIndicator();
      setTimeout(function() {
        Shared.callAjax(Routes.owner_logout_path(), {}, 'html', 'delete')
        if(gon.is_plan_akapon) {
          window.location.href = 'https://kanritools.com/';
        } else {
          window.location.href = 'https://createcloud.jp/';
        }
      }, 1000);
    }).fail(function(result) {
      Popup.alert('更新は失敗しました。', '', '', { popupCustomClass: 'w-auto' })
    })
  }

  handleShowChangePasswordModal(){
    $('#password_resets').modal('show')
  }

  handleCancelSubscriptionStep1(ele) {
    const objectPayment = JSON.parse($(ele).attr('data-object-unpaid-payment'))
    if (objectPayment.is_bank) {
      $('#modalCancelCompanyWithBank').modal('show')
    } else {
      this.handleShowPopupCancelComnpanyAfterStep1(ele)
    }
  }

  handleShowPopupCancelComnpanyAfterStep1(ele) {
    const amount = Number($(ele).attr('data-amount-payment-when-cancel'))
    $('body').attr('data-has-changed', 'true')
    if (amount > 0) {
      $(ele).attr('data-toggle', 'modal').attr('data-target', '#CancelPlanModalAmountPayment')
    } else {
      $('#js-will_cancel_subscription').removeClass('d-none')
      $('#subscriptions_cancel_subscription').val('please_cancel_subscription');
    }
    Popup.alert('「この内容で更新する」から更新後、解約になります。')
  }

  showPopupWarningWhenPaymentDelayed() {
    if (gon.current_subscription.payment_method === this.paymentMethod['credit_card']) {
      $('#WarningPaymentDelayWithStripe').modal('show')
    } else if (gon.current_subscription.payment_method === this.paymentMethod['bank']) {
      $('#WarningPaymentDelayWithBank').modal('show')
    }
  }

  submitNewPlan(ele, new_logic=false) {
    let new_membership = Number($('#input_change_membership_plan').val());
    if (gon.membership_plan.free_id.includes(new_membership)) {
      this.hasChangeSetting()
      return;
    }
    this.checkStatusChangePlan = true
    if (!$('input#subscriptions_payment_method').val()) {
      if (new_logic) {
        $('#plan_header_in_draft_mode').val('true');
        $('#plan_header_first_time_payment_method_flow').val('true');
        const payment_term = $('#subscriptions_payment_term').val();
        if(payment_term == 'year'){
          $('input[name="payment-term_stripe"][value="year"]').prop('checked', true);
        }
        this.showFlowModal('changePaymentMethodModal');
      } else {
        $('#ChangePaymentMethod').modal('show')
      }
    } else if ((gon.current_subscription.payment_method === this.paymentMethod['credit_card'] ||
      $('input#subscriptions_payment_method').val() === this.paymentMethod['credit_card']) &&
      (!gon.current_subscription.has_card && !$('#subscription_credit_card_number').val() && !this.hasCard)
    ) {
      $('#CreditCard').modal('show')
    }

    this.hasChangeSetting()
  }

  _showAddCardOrChangePlan() {
    this.clickFromChangePlanBtn = true;
    if (this.hasCard || gon.current_subscription.has_card) {
      $('#changePlanAndPaymentTermModal').modal('show')
    } else {
      $('#CreditCard').modal('show')
    }
  }

  handleShowChangePaymentMethod(ele) {
    const me = this;
    setTimeout(function() {
      if ($('input#subscriptions_payment_method').val() === me.paymentMethod['credit_card']) {
        if (gon.current_subscription.has_card || !!$('#subscription_credit_card_number').val() || me.hasCard) {
          if (me.clickFromChangePlanBtn) {
            $('#changePlanAndPaymentTermModal').modal('show')
          }
        } else {
          $('#CreditCard').find('button.btn-back-credit').attr('from-modal', 'ChangePaymentMethod')
          $('#CreditCard').modal('show')
        }
      } else {
        if (me.clickFromChangePlanBtn) {
          $('#changePlanAndPaymentTermModal').modal('show')
        }
      }
    }, 300)
  }

  handleConfirmCardModal(ele, call_from_header = false) {
    const $ele = $(ele);
    const me = this
    const fromModal = $ele.parents('#CreditCardConfirm').attr('from-modal')
    const data = {
      card_number: $('#number_credit_card').val(),
      expire: [$('#year_expire_credit_card').val(), $('#month_expire_credit_card').val()],
      security_code: $('#security_code_credit_card').val(),
      card_holder: $('#name_credit_card').val()
    }
    const card_ids_temp_added = $('#card_ids_temp_added').val();
    const url = Routes.owner_cards_path()
    const callAjax = Shared.callAjax(url, { credit_card: data, card_ids_temp_added: card_ids_temp_added, save_card: call_from_header }, 'html')
    callAjax.done(function(result) {
      $('#cards-list-section').html(result);
      $('#cards-button').removeClass('d-none');

      me.creditCardInfoChangedText();
      me.setCardDefaultSelected();
      me.handleRemoveCardsTemporaryDelete();

      $('body').attr('data-has-changed', 'true');
      if (fromModal == 'creditCardSelect') {
        feather.replace();
        $(`#${fromModal}`).modal('show')
      } else {
        const isCardDefaultInvalid = $('input#js-card-is-default-and-invalid').val()
        if (me.clickFromChangePlanBtn && !isCardDefaultInvalid) {
          $('#changePlanAndPaymentTermModal').modal('show')
        }
      }
      $('#WarningPaymentDelayWithBank').modal('hide')
      $('#WarningPaymentDelayWithStripe').modal('hide')
      const numberOfCard = parseInt($('p#number-of-card-label-text').text()) || 0;
      const numberDefaultCard = $('input#js-number-default-card').val()
      $('p#number-of-card-label-text').text(`${numberOfCard + 1}個のクレジットカード情報が設定されています。`)
      $('a#card-number-label-btn-text').text(`末尾●●●●${numberDefaultCard}`)
      $('#js-will_change_credit_card_to').attr('data-customer-id', 'true')
      me._resetCardForm();
      if ((!$('#subscriptions_payment_method').val() || $('#subscriptions_payment_method').val() !== me.paymentMethod['credit_card']) && !call_from_header) {
        me.popupConfirmAutoSetPaymentMethodStripe()
      }
      setTimeout(function() {
        Shared.callAjax(Routes.check_confirm_setup_intents_owner_cards_path(), {}, 'json', 'GET').done(function(resp) {
          if (resp.has_setup_intents) {
            const stripe = Stripe(gon.stripe_publishable_key);
            if (resp.client_secret) {
              stripe.confirmCardSetup(resp.client_secret)
            } else {
              me._showPopupInformToUserNeedVerifyCard()
            }
          }
        })
      }, 50)
      const draft_mode = $('#plan_header_in_draft_mode').val();
      const first_time_payment_method_flow = $('#plan_header_first_time_payment_method_flow').val();
      if (draft_mode == 'true' && first_time_payment_method_flow == 'true') {
        $("#changePaymentMethodModal").modal('hide');
        $("#CreditCard").modal('hide');
        $('#plan_header_first_time_payment_method_flow').val('false');
        me.render_text_with_change_plan_header_modal();
      } else if (first_time_payment_method_flow == 'true') {
        $("#changePaymentMethodModal").modal('hide');
        $("#CreditCard").modal('hide');
        $('#plan_header_first_time_payment_method_flow').val('false');
        me.showConfirmPaymentMethodModal('stripe');
      }
    })
    .fail(function(result) {
      const message = `現在の支払方法で決済できませんでした。<br>恐れ入りますが、別のクレジットカードをご利用ください。<br><br>[ERR: ${result.responseText}]`
      Popup.alert(message, '', '', { popupCustomClass: 'w-auto' })
      $('#CreditCard').modal('show')
    })
  }

  popupConfirmAutoSetPaymentMethodStripe() {
    if (gon.current_subscription?.free_plan) { return }

    Popup.confirm(`支払方法をクレジットカード（月払い）<br>に設定しますか？`,
    {
      success: () => {
        this.autoSetPaymentMethod(this.paymentMethod['credit_card'])
      },
      cancel: () => { return },
      confirmText: 'OK',
      cancelText: '後にする',
      width: 'auto'
    })
  }

  handleHideNotifyBankTransferApprovedModal() {
    Shared.callAjax(Routes.hidden_notify_bank_transfer_approved_modal_owner_users_path());
  }

  handleChangePaymentMethodBankTransferApprovedModal() {
    $('#bank_radio_button').prop('checked', true);
    $('#subscriptions_payment_method').val(this.paymentMethod['bank']);
    $('#bankTransferApprovedConfirmModal').modal('show');
  }

  popupConfirmAutoSetPaymentMethodBank() {
    if (
        gon.contract_info?.is_skip_warning_set_bank_method ||
        gon.contract_info?.is_change_bank_to_credit ||
        gon.current_subscription?.free_plan ||
        $(`input:radio[value='${this.paymentMethod["bank"]}'][name='payment_method']`).length == 0 ||
        $(`input:radio[value='${this.paymentMethod["bank"]}'][name='payment_method']`).prop("disabled") ||
        (!!$("#subscriptions_payment_method").val() &&
        $("#subscriptions_payment_method").val() === this.paymentMethod["bank"])
    ) {
      return;
    }

    $('#notify-bank-transfer-approved-modal').modal('show');
  }

  autoSetPaymentMethod(payment_method) {
    $(`input:radio[value='${payment_method}'][name='payment_method']`).prop('checked', true).trigger('click')
    $('#submit_change_payments').trigger('click');
  }

  handleNotChangePlanBtn(event) {
    event.preventDefault();
    if (gon.current_subscription.free_plan && !this.checkStatusChangePlan) {
      this.clickFromChangePlanBtn = true;
    } else {
      this.clickFromChangePlanBtn = false;
    }
  }

  addNewCreditCard(event) {
    event.preventDefault();
    $('#creditCardSelect').modal('hide')
    $('#js-submit_credit_card').attr('from-modal', 'creditCardSelect')
    $('#CreditCard').find('button.btn-back-credit').attr('from-modal', $(event.target).parents('div.modal').attr('id'))
    $('#CreditCard').modal('show')
  }

  handleBtnBackCreditCard(ele) {
    const modal = $(ele).attr('from-modal')
    if (modal === 'creditCardSelect') {
      this.showCardsList(this)
    }
    $(`#${modal}`).modal('show')
  }

  handleSetDefaultCard(ele) {
    const $ele = $(ele);
    const me = this;
    const cardId = $ele.attr('data-card-id');

    $('a#card-number-label-btn-text').text(`末尾●●●●${$ele.attr('data-card-last4')}`)
    $('.trash-area-cards').removeClass('d-none');
    $(`#btn-delete-of-card_${cardId}`).addClass('d-none')
    $('span.set-default-card').addClass('icon-uncheck').removeClass('icon-check').html('');
    $ele.removeClass('icon-uncheck');
    $ele.html('&#10004;')
    $ele.addClass('icon-check')
    $('#subscriptions_default_card_id').val(ele.dataset.cardId);

    $('#js-number-default-card').val($ele.attr('data-card-last4'));
    $('#js-name-default-card').val($ele.attr('data-card-name'));

    this.creditCardInfoChangedText();
    this.hasChangeSetting();
  }

  creditCardInfoChangedText() {
    if (
      $('#card_ids_temp_added').length != 0 && $('#card_ids_temp_added').val() != '[]' ||
      $('#subscriptions_card_ids_will_be_deleted').length != 0 && $('#subscriptions_card_ids_will_be_deleted').val() != '[]' ||
      $('#subscriptions_default_card_id').data('original-default-card-id') != $('#subscriptions_default_card_id').val()
    ) {
      $('#js-credit-card-info-changed').html('変更後更新されます。');
    } else {
      $('#js-credit-card-info-changed').html('');
    }
  }

  showCardsList(ele) {
    this.clickFromChangePlanBtn = false;
    const url = Routes.owner_cards_path()
    var me = this;

    let card_ids_temp_added = $('#card_ids_temp_added').val();
    const callAjax = Shared.callAjax(url, {card_ids_temp_added: card_ids_temp_added}, 'html', 'GET')
    callAjax.done(function(result) {
      $('#cards-list-section').html(result);
      $('#cards-button').removeClass('d-none');
      feather.replace();
      me.handleRemoveCardsTemporaryDelete();
      me.setCardDefaultSelected();
      $('#creditCardSelect').modal('show')
    });
  }

  handleRemoveCardsTemporaryDelete() {
    let card_id_will_deleted = JSON.parse($('#subscriptions_card_ids_will_be_deleted').val());
    card_id_will_deleted.forEach((cardId) => {
      $(`span.set-default-card[data-card-id=${cardId}]`).closest('.credit-data').remove();
    });
  }

  setCardDefaultSelected() {
    let subscriptions_default_card_id = $('#subscriptions_default_card_id').val();
    if (!!subscriptions_default_card_id) {
      const $ele = $(`span.set-default-card[data-card-id=${subscriptions_default_card_id}]`);
      const div_credit_data = $ele.closest('div.credit-data').find('span.set-default-card');

      $('#js-number-default-card').val(div_credit_data.data('card-last4'));
      $('#js-name-default-card').val(div_credit_data.data('card-name'));

      $('.trash-area-cards').removeClass('d-none');
      $(`#btn-delete-of-card_${subscriptions_default_card_id}`).addClass('d-none')
      $('span.set-default-card').addClass('icon-uncheck').removeClass('icon-check').html('');
      $ele.removeClass('icon-uncheck');
      $ele.html('&#10004;')
      $ele.addClass('icon-check')
    }
  }

  handleDeleteCard(ele, cardId) {
    const $ele = $(ele);
    var me = this;
    const cardNumber = $ele.attr('data-card-last4');
    const cardName = $ele.attr('data-card-name');
    const cardExpMonth = $ele.attr('data-card-exp-month');
    const cardExpYear = $ele.attr('data-card-exp-year');
    Popup.confirm(`
        <div class="h5 font-weight-normal  mt-n4 mb-n4">
          クレジットカード番号　****${cardNumber}
          クレジットカード名義名　${cardName}
          有効期限　${cardExpMonth}月${cardExpYear}年<br>
          上記情報を削除してよろしいですか？
        </div>
      `, {
        success: () => {
          let idsCard = $('#subscriptions_card_ids_will_be_deleted').val();
          let idsCardArray = JSON.parse(idsCard);
          idsCardArray.push(cardId);
          $('#subscriptions_card_ids_will_be_deleted').val(`[${idsCardArray}]`);

          let cardIdsWillAdded = JSON.parse($('#card_ids_temp_added').val());
          $('#card_ids_temp_added').attr('value', JSON.stringify(cardIdsWillAdded.filter(id => id != parseInt(cardId))));
          me.creditCardInfoChangedText();
          $ele.closest('.credit-data').remove();
          this.hasChangeSetting();
        },
        cancel: () => { return },
        confirmText: 'OK',
        cancelText: '戻る',
        width: '35rem'
      }
    )
  }

  _resetCardForm() {
    this.hasCard = true;
    $('#number_credit_card').val('');
    $('#year_expire_credit_card').val($("#year_expire_credit_card option:first").val())
    $('#month_expire_credit_card').val($("#month_expire_credit_card option:first").val())
    $('#security_code_credit_card').val('')
    $('#name_credit_card').val('')
  }

  checkErrorOfRegexKatana(value) {
    const regex_katakana_name = /^[ァ-・ヽヾ゛゜ー ( )（）]+$/;
    return regex_katakana_name.test(value)
  }

  async nextInputInfoPaid(ele) {
    const regex_phone_number = /\d[0-9]{0,9}-[0-9]{1,9}-[0-9]{1,9}$/
    const email_regex = /(\b[^@\s]+)@((?:[-a-z0-9]+\.)+[a-z]{2,})$/;
    const postalCodeRegex =/(^[0-9]{3}-[0-9]{4}$)/;
    const form = $(ele).parents('form#new_company_info_bank_transfer');
    let isCheck = true
    const listInputKatakana = [
      'company_info_bank_transfer_first_name_kana_of_ceo', 'company_info_bank_transfer_last_name_kana_of_ceo',
      'company_info_bank_transfer_company_name_kana', 'company_info_bank_transfer_first_name_kana_of_pic',
      'company_info_bank_transfer_last_name_kana_of_pic'
    ]
    let isInputBlank = false
    let isKatanaError = false
    let isPhoneError = false
    let isInputMaxLength = false
    await form.find("input[type!='hidden']").not('.not_required').toArray().forEach(input => {
      const inputValue = $(input).val()
      if(inputValue.trim() === '') {
        isCheck = false
        isInputBlank = true
        Shared.showInputError($(input), 'この項目は未入力です。')
      } else if (listInputKatakana.includes($(input).attr('id')) && !this.checkErrorOfRegexKatana(inputValue)) {
        isCheck = false
        isKatanaError = true
        Shared.showInputError($(input), '全角カナを50文字以内になるように入力してください。')
      } else if ($(input).attr('id') === 'company_info_bank_transfer_mobile_number' &&
                 (!regex_phone_number.test(inputValue) || inputValue.length > 25)) {
        isCheck = false
        isPhoneError = true
        Shared.showInputError($(input), '半角英数とハイフンで25文字以内になるように入力してください。')
      } else if ($(input).attr('id') === 'company_info_bank_transfer_email' && !email_regex.test(inputValue)) {
        isCheck = false
        Shared.showInputError($(input), 'メールアドレスのフォーマットが間違っています。')
      } else if ($(input).attr('id') === 'company_info_bank_transfer_postal_code' &&
                 !postalCodeRegex.test(inputValue)) {
        isCheck = false
        Shared.showInputError($(input), '郵便番号は正しくありません。<br>アカウント情報を更新してください。')
      } else if (inputValue.length > 50) {
        isCheck = false
        isInputMaxLength = true
        Shared.showInputError($(input), '50文字以内になるように入力してください。')
      } else {
        Shared.removeClassInInputError($(input))
      }
    })
    checkZipCode()
    if (isInputBlank) toastr.error('この項目は未入力です。', '', { closeButton: true, progressBar: true });
      if (isInputMaxLength) toastr.error('50文字以内になるように入力してください。', '', { closeButton: true, progressBar: true });
      if (isPhoneError) {
        toastr.error(
          '半角英数とハイフンで25文字以内になるように入力してください。',
          '', { closeButton: true, progressBar: true }
        );
      }
      if (isKatanaError) {
        toastr.error(
          '全角カナを50文字以内になるように入力してください。',
          '', { closeButton: true, progressBar: true }
        );
      }

    if (!isCheck) return
    form.find('input').attr('readonly', true);
    form.find('div#list-button-step1').find('button').addClass('d-none')
    form.find('div#list-button-step2').find('button').removeClass('d-none')
    form.find('#text_header_modal_paid_1').addClass('d-none')
    form.find('#text_header_modal_paid_2').removeClass('d-none')
    $('#applicationBankTransferForm').modal('hide')
    setTimeout(() => {
      $('#applicationBankTransferForm').modal('show');
    }, 500)
  }

  backToInputCompanyInfoBank(ele) {
    const form = $(ele).parents('form#new_company_info_bank_transfer');
    form.find('input').removeAttr('readonly');
    form.find('div#list-button-step2').find('button').addClass('d-none')
    form.find('div#list-button-step1').find('button').removeClass('d-none')
    form.find('#text_header_modal_paid_1').removeClass('d-none')
    form.find('#text_header_modal_paid_2').addClass('d-none')
    setTimeout(() => {
      $('#applicationBankTransferForm').modal('show');
    }, 500)
  }

  saveCompanyInfoBank(ele, call_from_header=false) {
    const form = $('form#new_company_info_bank_transfer');
    $(ele).attr('disabled', true)
    const formData = $(form[0]).serializeJSON();
    const ajaxCall = Shared.callAjax(form.attr('action'), formData)
    ajaxCall.done(function (result) {
      if (result.success) {
        $('#applicationBankTransferForm').modal('hide')
        if (call_from_header) {
          $('#applicationBankTransferSuccess').modal('show');
          $('#request-payment-to-paid-modal').modal('hide');
        } else {
          Popup.alert('銀行振込申請が完了しました。')
          $('#text-with-status-company-in-paid').html('銀行振込審査中です。')
        }
      } else {
        Popup.alert(result.message)
        $(ele).removeAttr('disabled')
      }
    })
  }

  validatePostalCodeAndPhone(event) {
    const ele = $(event.target)
    $(ele).val($(ele).val().replace(/[^0-9\-]/g,''));
  }

  render_text_with_change_plan(new_plan_index, currentPaymentMethod, newPaymentMethod) {
    this.data_membership_plan = JSON.parse($('#js-store_all_data_to_handle').attr('data-membership_plan') || {});
    const currentPaymentTerm = $('#ChangePaymentMethod').data('payment-term')
    this.data_membership_plan.push([4, 'supplier', 0])
    let text_price_with_bank_and_month;
    let text_price_with_bank_and_year;
    let text_price_with_stripe_and_month;
    let text_price_with_stripe_and_year;
    let text_with_info_plan_and_bank_and_month;
    let text_with_info_plan_and_bank_and_year;
    let text_with_info_plan_and_stripe_and_month;
    let text_with_info_plan_and_stripe_and_year;
    let newPlan = this.data_membership_plan.filter((plan) => { return plan[0] === new_plan_index })[0]
    let plan_name = newPlan[1]
    if (newPlan[2] === 0) {
      text_price_with_bank_and_month = '※プラン選択後に金額確定'
      text_price_with_bank_and_year = '※プラン選択後に金額確定'
      text_price_with_stripe_and_month = '※プラン選択後に金額確定'
      text_price_with_stripe_and_year = '※プラン選択後に金額確定'
      plan_name = I18n.t(`enums.membership_plan.name.${plan_name}`)
      let text = this.fetchtextInfoForCurrentMethodAndPlanFree(
        currentPaymentMethod, currentPaymentTerm, 'bank', 'month', plan_name
      )
      text_with_info_plan_and_bank_and_month = text
      text = this.fetchtextInfoForCurrentMethodAndPlanFree(
        currentPaymentMethod, currentPaymentTerm, 'bank', 'year', plan_name
      )
      text_with_info_plan_and_bank_and_year = text
      text = this.fetchtextInfoForCurrentMethodAndPlanFree(
        currentPaymentMethod, currentPaymentTerm, 'stripe', 'month', plan_name
      )
      text_with_info_plan_and_stripe_and_month = text
      text = this.fetchtextInfoForCurrentMethodAndPlanFree(
        currentPaymentMethod, currentPaymentTerm, 'stripe', 'year', plan_name
      )
      text_with_info_plan_and_stripe_and_year = text
    } else {
      const price = newPlan[2]
      text_price_with_bank_and_month = `${Shared.numberToCurrency(price)}円（税別）`
      text_price_with_bank_and_year = `${Shared.numberToCurrency(price * 10)}円（税別）`
      text_price_with_stripe_and_month = `${Shared.numberToCurrency(price)}円（税別）`
      text_price_with_stripe_and_year = `${Shared.numberToCurrency(price * 10)}円（税別）`
      if (currentPaymentMethod === newPaymentMethod) {
        let text = this.fetchTextForCurrentPaymentMethod(currentPaymentMethod, currentPaymentTerm, 'bank', 'month')
        text_with_info_plan_and_bank_and_month =
          `${text}次回のお支払期限は${gon.contract_info.date_with_bank_and_month}です。`
        text = this.fetchTextForCurrentPaymentMethod(currentPaymentMethod, currentPaymentTerm, 'bank', 'year')
        text_with_info_plan_and_bank_and_year =
          `${text}次回のお支払期限は${gon.contract_info.date_with_bank_and_year}です。`
        text = this.fetchTextForCurrentPaymentMethod(currentPaymentMethod, currentPaymentTerm, 'stripe', 'month')
        text_with_info_plan_and_stripe_and_month =
          `${text}次回決済日は${gon.contract_info.date_with_stripe_and_month}です。`
        text = this.fetchTextForCurrentPaymentMethod(currentPaymentMethod, currentPaymentTerm, 'stripe', 'year')
        text_with_info_plan_and_stripe_and_year =
          `${text}次回決済日は${gon.contract_info.date_with_stripe_and_year}です。`
      } else {
        if (newPaymentMethod === 'stripe') {
          text_with_info_plan_and_bank_and_month = '申込後に決済されます。'
          text_with_info_plan_and_bank_and_year = '申込後に決済されます。'
          text_with_info_plan_and_stripe_and_month = '更新後に決済されます。'
          text_with_info_plan_and_stripe_and_year = '更新後に決済されます。'
        } else {
          text_with_info_plan_and_bank_and_month =
            `申込後のお支払い期限は${gon.contract_info.date_with_bank_and_month}です。`
          text_with_info_plan_and_bank_and_year =
            `申込後のお支払い期限は${gon.contract_info.date_with_bank_and_year}です。`
          text_with_info_plan_and_stripe_and_month = ``
          text_with_info_plan_and_stripe_and_year = ``
        }
        if (newPlan[4]) {
          text_price_with_bank_and_month = `${Shared.numberToCurrency(0)}円　※キャンペーン中`
          text_price_with_bank_and_year = `${Shared.numberToCurrency(price * 10 * (newPlan[5] / 12))}円（税別）※キャンペーン中`
          text_price_with_stripe_and_month = `${Shared.numberToCurrency(0)}円　※キャンペーン中`
          text_price_with_stripe_and_year = `${Shared.numberToCurrency(price * 10 * (newPlan[5] / 12))}円（税別）※キャンペーン中`
          text_with_info_plan_and_bank_and_month = '更新後に決済されます。'
          text_with_info_plan_and_bank_and_year += '（6ヶ月分は通常料金が決済されます）'
          text_with_info_plan_and_stripe_and_year += '（6ヶ月分は通常料金が決済されます）'
        }
      }
    }
    $('#text_price_with_bank_and_month').html(text_price_with_bank_and_month)
    $('#text_price_with_bank_and_year').html(text_price_with_bank_and_year)
    $('#text_price_with_stripe_and_month').html(text_price_with_stripe_and_month)
    $('#text_price_with_stripe_and_year').html(text_price_with_stripe_and_year)

    $('#text_with_info_plan_and_bank_and_month').html(text_with_info_plan_and_bank_and_month)
    $('#text_with_info_plan_and_bank_and_year').html(text_with_info_plan_and_bank_and_year)
    $('#text_with_info_plan_and_stripe_and_month').html(text_with_info_plan_and_stripe_and_month)
    $('#text_with_info_plan_and_stripe_and_year').html(text_with_info_plan_and_stripe_and_year)
  }

  render_text_with_change_plan_header_modal() {
    const _sel = ($('#plan_list_select').val() || '').split('_')[1];
    const _temp = $('#payment-term-year-temp').val();
    const payment_term = (_sel === 'year' || _sel === 'month') ? _sel
      : ((_temp === 'year' || _temp === 'month') ? _temp : $('#subscriptions_payment_term').val());
    const payment_method = $('#subscriptions_payment_method').val();
    const _gs = (typeof gon !== 'undefined' && gon.current_subscription) ? gon.current_subscription : {};
    const _settled = _gs.payment_method === 'bank'
      || _gs.has_card || !!$('#subscription_credit_card_number').val() || this.hasCard;
    if (!_settled || (!$('input#subscriptions_payment_method').val() && !payment_method)) {
      $('#plan_header_in_draft_mode').val('true');
      $('#plan_header_first_time_payment_method_flow').val('true');
      this.showFlowModal('changePaymentMethodModal');
      return;
    }

    const new_plan_id = Number($('#plan_list_select')?.val()?.split('_')[0]);
    Shared.callAjax(Routes.handle_check_update_subscription_owner_subscriptions_path(), { plan_id: new_plan_id, payment_term: payment_term, payment_method: payment_method })
    .done(function(response) {
      $(".submit-subscription-update-info").data("price_valid", "valid");
      $(".submit-subscription-update-info").data('error_message', '');
      Shared.showModalForElement('#changePlanConfirmModal');
      ['upgradePlanPaymentModal','changePaymentMethodModal','changePlanAndPaymentTermModal'].forEach(function(_m){
        var _el = document.getElementById(_m);
        if (_el && _el.classList.contains('show')) {
          $(document).one('hidden.bs.modal', '#' + _m, function(){
            $('#subscriptions_payment_term').val(payment_term);
            $('#subscriptions_payment_method').val(payment_method);
            if ($('.modal.show').length) {
              $('body').addClass('modal-open');
              if ($('.modal-backdrop').length === 0) $('<div class="modal-backdrop fade show"></div>').appendTo(document.body);
            }
          });
          $('#' + _m).modal('hide');
        }
      });
      const containers = $('#changePlanConfirmModal').find('.payment-info-container');
      containers.eq(0).addClass('d-none');
      containers.eq(1).removeClass('d-none');
      $('#changePlanConfirmModal').find('#charged_date').text(response.charged_date);
      $('#changePlanConfirmModal').find('#old_plan').html(`<b>【現在】</b>${response.old_plan_name}プラン：${response.old_plan_price}<span>（税別）</span>`);
      $('#changePlanConfirmModal').find('#new_plan').html(`<b>【変更後】</b>${response.new_plan_name}プラン：${response.new_plan_price}<span>（税別）</span>`);
      // if (response.is_upgrade) {
      //   $('#changePlanConfirmModal').find('.payment-detail').html(`
      //     ${response.new_plan_name}プランへ変更すると、${response.time_line}分の<br/>
      //     先払い金額 <b><span id="amount_reporate">${response.amount_reporate}</span></b> を差引いた <b><span id="amount_will_pay">${response.amount_will_pay}</span></b> が決済されます。<br/>
      //     決済後、プラン変更後の次回決済日は「<span id="next_payment_date">${response.next_payment_date}</span>」になります。
      //   `);
      // } else {
      //   $('#changePlanConfirmModal').find('.payment-detail').html(`
      //     ${response.new_plan_name}プランへ変更すると、${response.time_line}分の<br/>
      //     利用可能期間については返金は行っておりません。<br/>
      //     プラン変更時の決済額は0円です。<br/>
      //     決済後、プラン変更後の次回決済日は「<span id="next_payment_date">${response.next_payment_date}</span>」になります。
      //   `);
      // }
      $('#changePlanConfirmModal').find('.payment-detail').addClass('d-none');
      $('#changePlanConfirmModal').find('#new_plan_info').text(`${response.new_plan_name}プランに変更すると、ご登録の${response.payment_method == 'stripe' ? 'クレジットカード' : '銀行振込'}`)
      $('#changePlanConfirmModal').find('#amount_will_pay_confirm').text(response.amount_will_pay);
      $('#changePlanConfirmModal').find('#next_payment_date').text(response.next_payment_date);
      if (response.payment_method == 'stripe') {
        $('#changePlanConfirmModal').find('#payment_method_card').text(`（末尾${response.last4_card}）`);
      }
      $('#changePlanConfirmModal').find('.modal-title').text(`${response.new_plan_name}プランに切り替える`);
    })
    .fail(function(response) {
      Popup.alert(response.responseJSON.error);
      $(".submit-subscription-update-info").data("price_valid", "invalid");
      $(".submit-subscription-update-info").data('error_message', response.responseJSON.error);
    })
  }

  show_text_change(new_membership) {
    let data_membership_plan = $('#js-store_all_data_to_handle').attr('data-membership_plan');
    let current_membership = Number($('#js-btn_show_modal_confirm_change_subscription').attr('data-current-member-plan-id'));

    if (data_membership_plan) {
      data_membership_plan = JSON.parse(data_membership_plan);
    }

    if (data_membership_plan && current_membership != new_membership) {
      let newPlan = data_membership_plan.filter((plan) => { return plan[0] === new_membership });
      if (newPlan && newPlan[0]) {
        let planName = newPlan[0][1];
        $('#js-will_change_subscription_to').html(
          `変更後「${I18n.t(`enums.membership_plan.name.${planName}`)}」に変わります。`
        );
      } else {
        $('#js-will_change_subscription_to').html('');
      }
    } else {
      $('#js-will_change_subscription_to').html('');
    }
  }

  setup_change_plan(new_membership, payment_term) {
    let paymentMethodText = '';
    let paymentTermText = '';
    const current_payment_term = $('#js-store_all_data_to_handle').attr('data-current-payment-term');
    const current_payment_method = $('#js-store_all_data_to_handle').attr('data-current-payment-method');
    $('#changePlanAndPaymentTermModal').modal('hide')
    $('#plan_list_select').val(`${new_membership}_${payment_term}`);
    $('#subscriptions_payment_term').val(payment_term);
    this.show_text_change(new_membership)
    if ( payment_term != current_payment_term) {
      if (payment_term == "month") {
        paymentTermText = '月払い';
      } else if (payment_term == "year") {
        paymentTermText = '年払い';
      }
      if (current_payment_method == "bank") {
        paymentMethodText = '銀行振込';
      } else if (current_payment_method == "stripe") {
        paymentMethodText = 'クレジットカード';
      }
      $('#js-will_change_payment_to').html('変更後' + paymentMethodText + '（' + paymentTermText + '）に変わります。');
    } else {
      $('#js-will_change_payment_to').html('');
    }
    $('#change_plan_btn').removeClass('d-none');
  }

  fetchtextInfoForCurrentMethodAndPlanFree(currentPaymentMethod, currentPaymentTerm, payment_method, payment_term, plan_name) {
    if (payment_method === currentPaymentMethod && payment_term === currentPaymentTerm) {
      return '現在利用中の支払方法です。'
    } else {
      return `${plan_name}プランは決済されません。`
    }
  }

  fetchTextForCurrentPaymentMethod(currentPaymentMethod, currentPaymentTerm, payment_method, payment_term) {
    if (payment_method === currentPaymentMethod && payment_term === currentPaymentTerm) {
      return '現在利用中の支払方法です<br>'
    } else {
      return ''
    }
  }

  checkCampaignCode(action) {
    var content = ""
    var parent = $(".group-apply-campaign-code");
    var campaign_code = parent.find("#campaign_code").val()
    const me = this;
    Shared.callAjax(Routes.check_code_owner_campaigns_path(), { campaign_code: campaign_code }).done(function(result) {
      if(result.data.status == "invalid") {
        content = `<p>このキャンペーンコードは無効です。</p>`
        if(action === 'register') {
          me._setCampaignCode('')
        }
      } else if(result.data.status == "expired") {
        content = `<p>このキャンペーンコードの期限は<br>${result.data.campaign.expired_date}で終了している為<br>ご利用頂けません。</p>`
      } else if(result.data.status == "duplicate") {
        content = `<p>このキャンペーンコードは既に適用しています。</p>`
      } else if (result.data.status == 'apply_your_self') {
          content =
            `<p>
              このキャンペーンコード<span class="d-inline-block">は無効です。</span><br>
              加盟店が「自身で作成したキャンペーンコード」<span class="d-inline-block">を利用する場合</span><br>
              1件以上の有料会員を保有している事が条件になります。<br>
              <a href="https://createcloud.jp/partner/" target="_blank">
              加盟店が自分のアカウントでキャンペーンコード<span class="d-inline-block">を利用する時</span>
              </a>
            </p>`
      } else {
        if(result.data.current_campaign.discount_value && result.data.current_campaign.expired_date) {
          $(".current_campaign_expired_date").html(`・有効期限：${result.data.current_campaign.expired_date}まで`)
          $(".current_campaign_discount_value").html(`・割引率：${result.data.current_campaign.discount_value}%`)
          $(".new_campaign_expired_date").html(`・有効期限：${result.data.campaign.expired_date}まで`)
          $(".new_campaign_discount_value").html(`・割引率：${result.data.campaign.discount_value}%`)
          $("#showCampaignCodeReplace").modal("show")
        } else {
          content = `<p>適用可能なキャンペーンコードです。<br>有料プランをご利用時に、<br>利用料から${result.data.campaign.discount_value}％値引きされます。<br>有効期限は${result.data.campaign.expired_date}です。</p>`
        }
        if(action === 'register') {
          me._setCampaignCode(campaign_code)
        }
        $("#js-need-to-submit-for-apply").html("変更後新しいキャンペーンコードに変わります。")
        $("#js-submit-membership-plan-check").data("can-submit", "can")
        $(".submit-subscription-update-info").data("can-submit", "can")
        $("#submit_subscription_update_info").removeClass("disabled")
        $("#submit_subscription_update_info").prop("disabled", false)
      }
      if(content != "") {
        $('body').attr('data-has-changed', 'true')
        Popup.alert(content);
      }
    })
  }

  checkChangeCampaignCodeField(elemt) {
    var campaign_code = $(elemt).val();
    $("#js-need-to-submit-for-apply").html("")
    if(campaign_code == '') {
      $("#js-submit-membership-plan-check").data("can-submit", "can")
      $(".submit-subscription-update-info").data("can-submit", "can")
      $('.button-check-campaign').addClass('disabled')
    } else {
      this.hasChangeSetting()
      $("#js-submit-membership-plan-check").data("can-submit", "cannot")
      $(".submit-subscription-update-info").data("can-submit", "cannot")
      $('.button-check-campaign').removeClass('disabled')
    }
  }

  submitMemberShip(elemt) {
    if($(elemt).data("can-submit") == "cannot") {
      $("#remindCheckCode").modal("show")
    } else {
      const submitLink = $("#js-submit-membership-plan")
      if (!!submitLink && submitLink.attr('data-select-plan') === 'true') {
        submitLink[0].click()
      }
    }
  }

  showPlan(element) {
    const $ele = $(element);
    if ($ele.attr('data-show-plans-akapon') === 'true') {
      $ele.text('Akaponプランを選択する')
      $ele.addClass('akaire-functions-color')
      $ele.removeClass('text-primary')
      $ele.attr('data-show-plans-akapon', 'false')
      $('div#title-plan-createcloud').addClass('d-flex').removeClass('d-none')
      $('div#title-plan-akapon').addClass('d-none').removeClass('d-flex')
      $('div#createcloud_plans_list').removeClass('d-none');
      $('div#akapon_plans_list').addClass('d-none');
      // $('div#changePlanAndPaymentTermModal').removeClass('akapon')
    } else {
      $ele.text('Create Cloudプランを選択する')
      $ele.addClass('text-primary')
      $ele.removeClass('akaire-functions-color')
      $ele.attr('data-show-plans-akapon', 'true')
      $('div#title-plan-createcloud').addClass('d-none').removeClass('d-flex')
      $('div#title-plan-akapon').addClass('d-flex').removeClass('d-none')
      $('div#createcloud_plans_list').addClass('d-none');
      $('div#akapon_plans_list').removeClass('d-none');
      // $('div#changePlanAndPaymentTermModal').addClass('akapon')
    }
  }

  showPopupEnterPostalCode(element) {
    const $ele = $(element);
    if (!$ele.hasClass('is-invalid')) {
      return;
    }
    if (!!$ele.val()) {
      Popup.alert(`<a href="${Routes.owner_edit_owner_path()}" target="_blank">「CRM＞アカウント情報」</a>
    ページの郵便番号を変更すると、<br>申請フォーム「郵便番号」情報が自動的に変更されます。`)
    } else {
      Popup.alert(`<a href="${Routes.owner_edit_owner_path()}" target="_blank">「CRM＞アカウント情報」</a>
      ページの郵便番号を入力してください。`)
    }
  }

  _showPopupInformToUserNeedVerifyCard() {
    Popup.confirm(
      `
        クレジットカードの仮登録が完了しました。

        ご登録のメールアドレス宛にクレジットカード会社から
        決済についての連絡メールが届きます。
        承認が完了したあと、もう一度お試しください。
      `,
      {
        success: () => { window.location.href = Routes.owner_total_info_path() },
        cancel: () => { window.location.href = Routes.owner_total_info_path() },
        confirmText: 'OK',
        cancelBtn: 'false',
        width: 'auto'
      }
    )
  }

  _setCampaignCode(campaignCode) {
    const url = new URL($("#js-submit-membership-plan").attr("href"))
    url.searchParams.set('campaign_code', campaignCode)
    $("#js-submit-membership-plan").attr("href", url)
  }

  hasChangeSetting() {
    $('body').attr('data-has-changed', 'true')
  }

  handleChangeMainAdmin(element) {
    this.hasChangeSetting();
    const select = $(element);
    if (select.val().toString() !== select.data('initial-value').toString()) {
      $('#mainAdminSettingsConfirmModal').modal('show');
    }
  }

  showCampaignCode(){
    $('#text-campaign-code').text('を入力後、「適用」＞「このプランを選択する」に進んでください。')
    $('.button-show-campaign').toggleClass('d-none');
    $('.group-apply-campaign-code').toggleClass('d-none');
    $('.group-apply-campaign-code').toggleClass('d-flex');
  }

  closeCampaignCode(){
    $('#text-campaign-code').text('を利用する場合は「入力する」をクリックしてください。')
    $('.button-show-campaign').toggleClass('d-none');
    $('.group-apply-campaign-code').toggleClass('d-none');
    $('.group-apply-campaign-code').toggleClass('d-flex');
    $('#campaign_code').val('');
    $('#js-submit-membership-plan-check').data("can-submit", "can");
  }

  handleSettingNotifyOfCompany(element, event) {
    let checkbox = $(element);
    if (checkbox.is(':checked')) {
      this._checkedCheckbox(checkbox, true)
      if (checkbox.val() == 'all_notify') {
        this._handleCheckboxSettingNotify(checkbox, false);
      } else {
        this._handleCheckboxSettingAllNotify(false)
      }
    } else {
      this._checkedCheckbox(checkbox, false)
      if (checkbox.val() == 'all_notify') {
        this._handleCheckboxSettingNotify(checkbox, true);
      } else {
        if ($('input[type="checkbox"][name="receive_notify"]:not(:checked)').length >= 3) {
          this._handleCheckboxSettingAllNotify(true)
        }
      }
    }
    $('#js-will_change_setting_noti_company').removeClass('d-none')
    this._setValueForReceiveNotify()
    $('#announcementSettingsModal').find('.payment-info-container').removeClass('d-none')
  }

  _handleCheckboxSettingNotify(checkbox, isChecked) {
    $('input[type="checkbox"][name="receive_notify"]').toArray().forEach((ele) => {
      if ($(ele).val() != checkbox.val()) {
        this._checkedCheckbox($(ele), isChecked)
      }
    });
  }

  _handleCheckboxSettingAllNotify(isChecked) {
    let checkbox = $('input[type="checkbox"][name="receive_notify"][value="all_notify"]')
    this._checkedCheckbox(checkbox, isChecked)
  }

  _checkedCheckbox(element, isChecked) {
    element.prop('checked', isChecked)
    element.parent().find('.checkbox_text').attr('data-content', isChecked ? '✓' : '')
  }

  _setValueForReceiveNotify() {
    let allNotify = $('input[type="checkbox"][name="receive_notify"][value="all_notify"]').is(':checked');
    let onlyImportant = $('input[type="checkbox"][name="receive_notify"][value="only_important"]').is(':checked');
    let notReport = $('input[type="checkbox"][name="receive_notify"][value="not_report"]').is(':checked');
    let inputReceiveNotify = $('input#subscriptions_receive_notify');
    if (allNotify) {
      inputReceiveNotify.val('all_notify');
    } else if (onlyImportant && notReport) {
      inputReceiveNotify.val('only_important_and_not_report');
    } else if (onlyImportant) {
      inputReceiveNotify.val('only_important_and_report');
    } else if (notReport) {
      inputReceiveNotify.val('only_not_report');
    }
    $('body').attr('data-has-changed', 'true');
  }

  showPopupIntroduceReport(event) {
    event.stopPropagation();
    $('#introduceReportModal').modal('show');
    event.preventDefault();
  }

  showCompanyMembers(event) {
    event.stopPropagation();
    const url = '/company/info/members'
    Shared.callAjax(url, {}, 'script', 'GET')
  }
  showAnnualPaymentModal(payment_method=null) {
    const payment_term = 'year';
    const new_plan_id = null;
    Shared.callAjax(Routes.handle_check_change_payment_term_owner_subscriptions_path(), { plan_id: new_plan_id, payment_term: payment_term, payment_method: payment_method })
    .done(function(response) {
      const containers = $('.annual-payment');
      containers.eq(0).removeClass('d-none');
      containers.eq(1).addClass('d-none');
      $('#annualPaymentModal').modal('show');
      $('.payment-detail').addClass('d-none');
      $('#annualPaymentModal').find('#charged_date').text(response.charged_date);
      $('#annualPaymentModal').find('#amount_monthly').html(`<b>【現在】</b>月払い：${response.amount_monthly}<span>（税別）</span>`);
      $('#annualPaymentModal').find('#amount_yearly').html(`<b>【変更後】</b>年払い：${response.amount_yearly}<span>（税別）</span>`)
      // $('#annualPaymentModal').find('#amount_save').text(response.amount_save);
      // $('#annualPaymentModal').find('#amount_reporate').text(response.amount_reporate);
      // $('#annualPaymentModal').find('#amount_will_pay').text(response.amount_will_pay);
      // $('#annualPaymentModal').find('#amount_calculation').text(`${response.amount_elapsed}－${response.amount_reporate}＝${response.amount_will_pay}`);
      // $('#annualPaymentModal').find('#reporate_period').text(`${response.reporate_period}`);
      // $('#annualPaymentModal').find('#paid_period').text(`${response.paid_period}`);
      if(response.payment_method === 'stripe'){
        $('#annualPaymentModal').find('#amount_will_pay_confirm').text(`（末尾${response.last4_card}）より差額分の ${response.amount_will_pay} が決済されます。`);
      } else {
        $('#annualPaymentModal').find('#amount_will_pay_confirm').text(response.amount_will_pay);
      }
      // $('#annualPaymentModal').find('#next_payment_date').text(response.next_payment_date);
      // $('#annualPaymentModal').find('#annual_payment_payment_method').val(response.payment_method);
    })
    .fail(function(response) {
      Popup.alert(response.responseJSON.error);
    })
  }

  showMonthlyPaymentModal(payment_method=null) {
    const payment_term = 'month';
    const new_plan_id = null;
    Shared.callAjax(Routes.handle_check_change_payment_term_owner_subscriptions_path(), { plan_id: new_plan_id, payment_term: payment_term, payment_method: payment_method })
    .done(function(response) {
      const containers = $('.monthly-payment');
      containers.eq(0).removeClass('d-none');
      containers.eq(1).addClass('d-none');
      $('#monthlyPaymentModal').modal('show');
      $('.payment-detail').addClass('d-none');
      $('#monthlyPaymentModal').find('#charged_date').text(response.charged_date);
      $('#monthlyPaymentModal').find('#amount_monthly').html(`<b>【現在】</b>月払い：${response.amount_monthly}<span>（税別）</span>`);
      $('#monthlyPaymentModal').find('#amount_yearly').html(`<b>【変更後】</b>年払い：${response.amount_yearly}<span>（税別）</span>`)
      if(response.payment_method === 'stripe'){
        $('#monthlyPaymentModal').find('#amount_will_pay_confirm').text(`（末尾${response.last4_card}）より差額分の ${response.amount_will_pay} が決済されます。`);
      } else {
        $('#monthlyPaymentModal').find('#amount_will_pay_confirm').text(response.amount_will_pay);
      }
    })
    .fail(function(response) {
      Popup.alert(response.responseJSON.error);
    })
  }

  showUpgradePlanPaymentModal(payment_method=null) {
    const me = this;
    const draft_mode = $('#plan_header_in_draft_mode').val();
    if (draft_mode == 'true') {
      this.render_text_with_change_plan_header_modal();
      return;
    }
    let data = { payment_method: payment_method }
    Shared.callAjax(Routes.handle_check_change_plan_payment_owner_subscriptions_path(), data)
    .done(function(response) {
      $('#change_plan_btn').addClass('d-none');
      const containers = $('#upgradePlanPaymentModal').find('.upgrade_plan_payment');
      containers.eq(0).removeClass('d-none');
      containers.eq(1).addClass('d-none');
      $('.payment-detail').addClass('d-none');
      me.showFlowModal('upgradePlanPaymentModal');
      $('#upgradePlanPaymentModal').find('#charged_date').text(response.charged_date);
      $('#upgradePlanPaymentModal').find('#amount_current').html(`<b>【現在】</b>${response.current_plan}プラン（${response.payment_term == 'year' ? '年' : '月'}払い）：${response.current_amount}<span>（税別）</span>`);
      if (response.max_plan) {
        $('#upgradePlanPaymentModal').find('.max-plan-alert').removeClass('d-none');
        $('#upgradePlanPaymentModal').find('.plan-select').removeClass('d-none');
        $('#upgradePlanPaymentModal').find('.choose-plan').removeClass('d-none');
        $('#upgradePlanPaymentModal').find('.plan-select-label').addClass('d-none');
      } else {
        $('#upgradePlanPaymentModal').find('.max-plan-alert').addClass('d-none');
        $('#upgradePlanPaymentModal').find('.plan-select').removeClass('d-none');
        $('#upgradePlanPaymentModal').find('.choose-plan').removeClass('d-none');
        $('#upgradePlanPaymentModal').find('.plan-select-label').removeClass('d-none');
      }
      const planSelect = $('#upgradePlanPaymentModal').find('#plan_list_select');
      planSelect.empty();
      planSelect.append(`<option value="" selected>変更するプランを選択してください。</option>`);      
      response.plan_select.forEach(function(plan) {
        const planName = plan[0];
        const planId = plan[1];
        const planPrice = plan[2];
        planSelect.append(`<option value="${planId}">${planName}プラン：${planPrice}</option>`);
      });
    })
  }

  async handleUpdateAnnualPaymentSubmit() {
    const password = $('#annualPaymentPassword').val()
    let data = await this.handleCheckPassword(password)
    if(data.success){
      const new_plan_id = null;
      $('#annualPaymentModal').find('#payment-password-instruction').removeClass('d-none');
      $('#annualPaymentModal').find('#wrong-password').addClass('d-none');
      this.handleUpdateChangePlanConfirm(new_plan_id, 'year')
    } else {
      $('#annualPaymentModal').find('#payment-password-instruction').addClass('d-none');
      $('#annualPaymentModal').find('#wrong-password').removeClass('d-none');
    }
  }

  async handleConfirmPaymentMethodSubmit() {
    const password = $('#handleConfirmPaymentMethodPassword').val()
    let data = await this.handleCheckPassword(password)
    if(data.success){
      $('#handleConfirmPaymentMethodModal').find('#payment-password-instruction').removeClass('d-none');
      $('#handleConfirmPaymentMethodModal').find('#wrong-password').addClass('d-none');
      this.handleUpdatePaymentMethod()
    }
    else {
      $('#handleConfirmPaymentMethodModal').find('#payment-password-instruction').addClass('d-none');
      $('#handleConfirmPaymentMethodModal').find('#wrong-password').removeClass('d-none');
    }
  }

  async handleUpdateMonthlyPaymentSubmit() {
    const password = $('#monthlyPaymentPassword').val()
    let data = await this.handleCheckPassword(password)
    if(data.success){
      const new_plan_id = null;
      $('#monthlyPaymentModal').find('#payment-password-instruction').removeClass('d-none');
      $('#monthlyPaymentModal').find('#wrong-password').addClass('d-none');
      this.handleUpdateChangePlanConfirm(new_plan_id, 'month')
    } else {
      $('#monthlyPaymentModal').find('#payment-password-instruction').addClass('d-none');
      $('#monthlyPaymentModal').find('#wrong-password').removeClass('d-none');
    }
  }

  async handleUpdateAnnualPayment() {
    Shared.loadingIndicator(); 
    await Shared.callAjax(Routes.handle_change_payment_term_yearly_owner_subscriptions_path()).done(function(response) {
      $('#annualPaymentModal').find('#payment-password-instruction').removeClass('d-none');
      $('#annualPaymentModal').find('#wrong-password').addClass('d-none');
      const successMessage = `
        <p>${response.payment_method == 'stripe' ? 'クレジットカード' : '銀行振込決済'}<span>（${response.amount}）</span>が完了しました。</p>
        <p>${response.current_plan}プランが年払いに変更されました。</p>
        <p>次回決済日は「${response.next_charge_date}」になります。</p>
      `;
      $('#annualPaymentModal').modal('hide');
      $('.modal').modal('hide');
      $('#changePaymentModalSuccess').modal('show');
      $('#changePaymentModalSuccess').find('#success-message-body').html(successMessage);
    }).fail(function(result) {
      Popup.alert('更新は失敗しました。', '', '', { popupCustomClass: 'w-auto' })
    })
  }

  async handleUpdatePaymentMethod() {
    Shared.loadingIndicator();
    const payment_method = $('#subscriptions_payment_method').val();
    await Shared.callAjax(Routes.handle_update_payment_method_owner_subscriptions_path({ payment_method: payment_method })).done(function(response) {
      $('#handleConfirmPaymentMethodModal').find('#payment-password-instruction').removeClass('d-none');
      $('#handleConfirmPaymentMethodModal').find('#wrong-password').addClass('d-none');
      const successMessage = `<p>支払方法が${response.payment_method == 'stripe' ? 'クレジットカード' : '銀行振込決済'}に変更されました。</p>`;
      $('#handleConfirmPaymentMethodModal').modal('hide');
      $('.modal').modal('hide');
      $('#changePaymentModalSuccess').modal('show');
      $('#changePaymentModalSuccess').find('#success-message-body').html(successMessage);
    }).fail(function(result) {
      Popup.alert('更新は失敗しました。', '', '', { popupCustomClass: 'w-auto' })
    })
  }

  async handleUpdateChangePlanConfirmSubmit() {
    const password = $('#changePlanConfirmPassword').val()
    let data = await this.handleCheckPassword(password)
    if(data.success){
      let new_membership = Number($('#input_change_membership_plan').val());
      if (!new_membership) { new_membership = Number(($('#plan_list_select').val() || '').split('_')[0]) || new_membership; }
      $('#changePlanConfirmModal').find('#payment-password-instruction').removeClass('d-none');
      $('#changePlanConfirmModal').find('#wrong-password').addClass('d-none');
      this.handleUpdateChangePlanConfirm(new_membership)
    } else {
      $('#changePlanConfirmModal').find('#payment-password-instruction').addClass('d-none');
      $('#changePlanConfirmModal').find('#wrong-password').removeClass('d-none');
    }
  }

  async handleUpgradePlanSubmit() {
    const password = $('#upgradePlanPaymentPassword').val()
    let data = await this.handleCheckPassword(password)
    $('#plan_header_in_draft_mode').val('false');
    if(data.success){
      const new_membership = Number($('#plan_list_select')?.val()?.split('_')[0]);
      $('#upgradePlanPaymentModal').find('#payment-password-instruction').removeClass('d-none');
      $('#upgradePlanPaymentModal').find('#wrong-password').addClass('d-none');
      this.handleUpdateChangePlanConfirm(new_membership)
    } else {
      $('#upgradePlanPaymentModal').find('#payment-password-instruction').addClass('d-none');
      $('#upgradePlanPaymentModal').find('#wrong-password').removeClass('d-none');
    }
  }
  async handleUpdateChangePlanConfirm(new_plan_id, payment_term=null) {
    Shared.loadingIndicator();
    const payment_method = $('#subscriptions_payment_method').val();
    const data = {
      plan_id: new_plan_id,
      payment_method: payment_method,
      payment_term: payment_term || (($('#plan_list_select').val() || '').split('_')[1]) || $('#subscriptions_payment_term')?.val(),
    }
    await Shared.callAjax(Routes.handle_update_subscription_owner_subscriptions_path(), data).done(function(response) {
      $('#changePlanConfirmModal').find('#payment-password-instruction').removeClass('d-none');
      $('#changePlanConfirmModal').find('#wrong-password').addClass('d-none');
      let successMessage = `
        <p>・${response.payment_method == 'stripe' ? 'クレジットカード' : '銀行振込'}決済（${response.amount}）が完了しました。</p>
        <p>・${response.current_plan}プラン（${response.current_payment_term == 'year' ? '年' : '月'}払い）から${response.new_plan}プラン（${response.new_payment_term == 'year' ? '年' : '月'}払い）に変更されました。</p>
        <p>※次回決済日は「${response.next_charge_date}」になります。</p>
      `;
      if (response.change_payment_method) {
        successMessage += `
          <p>※支払方法が${response.payment_method == 'stripe' ? 'クレジットカード' : '銀行振込'}決済に変更されました。</p>
        `;
      }
      $('#changePlanConfirmModal').modal('hide');
      $('.modal').modal('hide');
      $('#changePaymentModalSuccess').modal('show');
      $('#changePaymentModalSuccess').find('#success-message-body').html(successMessage);
    }).fail(function(result) {
      const message = `現在の支払方法で決済できませんでした。<br>恐れ入りますが、別のクレジットカードをご利用ください。<br><br>[ERR: ${result.responseJSON.message}]`
      Popup.alert(message, '', '', { popupCustomClass: 'w-auto' })
    })
  }

  handleShowChangePlanHeaderModal(ele, fileLimitHtml) {
    Shared.callAjax(Routes.handle_check_company_info_owner_subscriptions_path())
    .done(function(response) {
      Shared.showModalForElement('#changePlanModal');
      if (fileLimitHtml) { $('#fileLimitAlertInPlanModal').html(fileLimitHtml).removeClass('d-none'); }
      else { $('#fileLimitAlertInPlanModal').addClass('d-none'); }
      $('#changePlanModal').find('#plan_info_current_charged_date').text(`次回の決済日：${response.charged_date}`);
      $('#changePlanModal').find('#plan_info_current_plan_name').html(`現在のサブスクリプション：<b>${response.current_plan_name}</b>`);
      if(response.payment_method == 'stripe'){
        $('#changePlanModal').find('#plan_info_current_payment_info').text(`次回の決済額：￥${response.current_plan_price}/${response.payment_term == 'year' ? '年' : '月'}（税別）　クレジット｜${response.credit_brand}****${response.last4_card}`);
      } else if (response.payment_method == 'bank') {
        $('#changePlanModal').find('#plan_info_current_payment_info').text(`次回の決済額：￥${response.current_plan_price}/${response.payment_term == 'year' ? '年' : '月'}（税別）　Paidによる銀行振込決済 `);
      } else {
        $('#changePlanModal').find('#plan_info_current_payment_info').text(`次回の決済額：￥${response.current_plan_price}/${response.payment_term == 'year' ? '年' : '月'}（税別）　お支払方法なし｜クレジットカード情報なし `);
      }
      $('#changePlanModal').find('.item-menu_users').text(`チームメンバーの管理 （${response.user_count}）`);
      $('#changePlanModal').attr('data-current-member-plan-id', response.current_plan_id);
      $('#js-store_all_data_to_handle').attr('data-current-lisence-size', response.license_size);
      $('#js-store_all_data_to_handle').attr('data-current-payment-method', response.payment_method);
      $('#js-store_all_data_to_handle').attr('data-current-payment-term', response.payment_term);
      $('#js-store_all_data_to_handle').attr('data-membership_plan', JSON.stringify(response.membership_plan));
      $('#subscriptions_payment_method').val(response.payment_method);
      $('#subscriptions_payment_term').val(response.payment_term);
      if(response.disabled_paid){
        $('#bank_radio_button').prop('disabled', true);
        $('#bank_label').addClass('opacity-blur mr-2');
      }
    })
  }

  enableDraftMode(options={}) {
    const { payment_term, disable_draft_mode } = options;
    if (payment_term) {
      $('#subscriptions_payment_term').val(payment_term);
    }
    if (disable_draft_mode) {
     return;
    }
    $('#plan_header_in_draft_mode').val('true');
  }

  saveCardChanges() {
    const card_id_will_deleted = JSON.parse($('#subscriptions_card_ids_will_be_deleted').val());
    const default_card_id = $('#subscriptions_default_card_id').val();
    const data = {
      card_id_will_deleted,
      default_card_id
    }
    Shared.callAjax(Routes.handle_update_cards_owner_subscriptions_path(), data).done(function(response) {
      $('#creditCardSelect').modal('hide');
      $('#card-change-success').modal('show');
    }).fail(function(result) {
      Popup.alert(`${result.message}`, '', '', { popupCustomClass: 'w-auto' })
    })
  }

  goBackToContractInfo() {
    window.location.href = Routes.owner_total_info_path()
  }

  setPaymentMethodFirstTimeHeaderModal() {
    const draft_mode = $('#plan_header_in_draft_mode').val();
    const first_time_payment_method_flow = $('#plan_header_first_time_payment_method_flow').val();
    if (draft_mode == 'true' && first_time_payment_method_flow == 'true') {
      $('#plan_header_first_time_payment_method_flow').val('false');
      $('#changePaymentMethodModal').modal('show');
    }
    $('#card-change-success').modal('hide');
  }

  handleChangePaymentMethodHeaderModal(ele) {
    let paymentTermText = '';
    let paymentMethodText = '';
    const current_payment_method = $('#js-store_all_data_to_handle').attr('data-current-payment-method');
    const current_payment_term = $('#js-store_all_data_to_handle').attr('data-current-payment-term');
    const new_payment_method = $('input[name="payment_method"]:checked').val();
    const new_payment_term = $(`input[name="payment-term_${new_payment_method}"]:checked`).val();
    if (new_payment_method === this.paymentMethod['credit_card']) {
      if (!(gon.current_subscription.has_card || !!$('#subscription_credit_card_number').val() || this.hasCard)) {
        $('#CreditCard').find('button.btn-back-credit').attr('from-modal', 'ChangePaymentMethod')
        this.showFlowModal('CreditCard');
      }
    }
    if (new_payment_method != current_payment_method) {
      $('#subscriptions_payment_method').val(new_payment_method);
    } else {
      $('#subscriptions_payment_method').val(current_payment_method);
    }

    if (new_payment_term == "month") {
      paymentTermText = '月払い';
    } else if (new_payment_term == "year") {
      paymentTermText = '年払い';
    }

    if (new_payment_method == "bank") {
      paymentMethodText = '銀行振込';
    } else if (new_payment_method == "stripe") {
      paymentMethodText = 'クレジットカード';
    }

    if ($('#js-payment-method-and-term').data('exists-subscription') == 'false' && new_payment_term && new_payment_method)
      $('#js-payment-method-and-term').html(`${paymentMethodText}（${paymentTermText}）`)

    if (new_payment_method == current_payment_method && new_payment_term == current_payment_term)
      $('#js-will_change_payment_to').html('');
    else if (!!paymentMethodText && !!paymentTermText) {
      $('#js-will_change_payment_to').html('変更後' + paymentMethodText + '（' + paymentTermText + '）に変わります。');
      $('body').attr('data-has-changed', 'true')
    }

    if (new_payment_term != current_payment_term) {
      if(new_payment_method === this.paymentMethod['credit_card'] &&
        !gon.current_subscription.has_card && !$('#subscription_credit_card_number').val() && !this.hasCard
      ) {
        $('#plan_header_first_time_payment_method_flow').val('true');
        return;
      }

      $('#subscriptions_payment_term').val(new_payment_term);
      if (new_payment_term == 'year') {
        this.showAnnualPaymentModal(new_payment_method);
      } else {
        this.showMonthlyPaymentModal(new_payment_method);
      }
    } else {
      $('#subscriptions_payment_term').val(current_payment_term);
      const draft_mode = $('#plan_header_in_draft_mode').val();
      if (draft_mode == 'true') {
        $("#changePaymentMethodModal").modal('hide');
        if(new_payment_method === this.paymentMethod['credit_card'] && !this.hasCard) {
          $('#plan_header_first_time_payment_method_flow').val('true');
          return;
        }
        this.showUpgradePlanPaymentModal(new_payment_method)
        return;
      } else if (new_payment_method != current_payment_method && draft_mode == 'false') {
        if(new_payment_method === this.paymentMethod['credit_card'] &&
          !gon.current_subscription.has_card && !$('#subscription_credit_card_number').val() && !this.hasCard
        ) {
          $('#plan_header_first_time_payment_method_flow').val('true');
          return;
        }
        $("#changePaymentMethodModal").modal('hide');
        this.showConfirmPaymentMethodModal(new_payment_method);
        return;
      }
    }
    $("#changePaymentMethodModal").modal('hide');
  }
  showConfirmPaymentMethodModal(payment_method) {
    if (payment_method == 'stripe') {
      $('#handleConfirmPaymentMethodModal').find('.payment-info-confirm').html('支払方法がクレジットカードに変更されます。');
    } else {
      $('#handleConfirmPaymentMethodModal').find('.payment-info-confirm').html('支払方法が銀行振込に変更されます。');
    }
    $('#handleConfirmPaymentMethodPassword').val('');
    $('#handleConfirmPaymentMethodModal').modal('show');
  }
  handleStatsClick(ele, type) {
    Shared.callAjax('/company/info/invidual_stats', { type: type }, 'script', 'get').done(function(response) {
      $('#companyStatsTableModal').modal('show');
    })
  }

  handlePlanOptionSelect(ele, payment_method=null) {
    const planId = $(ele).val();
    const data = { plan_id: planId }
    if (payment_method) {
      data.payment_method = payment_method
    }
    Shared.callAjax(Routes.handle_check_change_plan_payment_owner_subscriptions_path(), data).done(function(response) {
      // $('#upgradePlanPaymentModal').find('#payment_detail').removeClass('d-none');
      $('#upgradePlanPaymentModal').find('#change_plan_btn').removeClass('d-none');
      // $('#upgradePlanPaymentModal').find('#amount_reporate').text(response.amount_reporate);
      // $('#upgradePlanPaymentModal').find('#amount_will_pay').text(response.amount_will_pay);
      // $('#upgradePlanPaymentModal').find('#next_payment_date').text(response.next_payment_date);
      if(response.payment_method === 'stripe'){
        $('#upgradePlanPaymentModal').find('#amount_will_pay_confirm').text(`（末尾${response.last4_card}）より差額分の ${response.amount_will_pay} が決済されます。`);
      } else {
        $('#upgradePlanPaymentModal').find('#amount_will_pay_confirm').text(response.amount_will_pay);
      }
    })
  }

  openPlanHeaderModal() {
    const toggleBtn = $('#plan-header-toggle-btn');
    if(toggleBtn && toggleBtn.length > 0) {
      toggleBtn.trigger('click');
    }
    else {
      window.location.href = Routes.owner_total_info_path();
    }
  }
  openPlanHeaderModalWithFileLimit(planName, maxNum) {
    var _name = planName || '';
    var _max = (maxNum === undefined || maxNum === null) ? '' : maxNum;
    var _html = 'ファイル数の上限に達しました。 現在の' + _name + 'プランでは最大' + _max + '個までです。<br>プランを変更すると追加できます。';
    $('.modal.show, .modal:visible').not('#changePlanModal').each(function(){ try { Shared.hideModalForElement('#' + this.id); } catch(e){} });
    this.handleShowChangePlanHeaderModal(null, _html);
  }

  openAnnouncementSettingsConfirmModal() {
    const settings = $('input#subscriptions_receive_notify').val();
    let announcement_settings_text = '';
    if (settings == 'all_notify') {
      announcement_settings_text = '「すべてのお知らせを受信する」';
    } else if (settings == 'only_important_and_not_report') {
      announcement_settings_text = '「すべて受信しない（重要な通知は除く）」と「レポートのみ受信しない」';
    } else if (settings == 'only_important_and_report') {
      announcement_settings_text = '「すべて受信しない（重要な通知は除く）」';
    } else if (settings == 'only_not_report') {
      announcement_settings_text = '「レポートのみ受信しない」';
    }
    announcement_settings_text = '<p>お知らせ通知が' + announcement_settings_text + 'に変更されます。</p>';
    $('#announcementSettingsConfirmModal').find('.payment-info-confirm').html(announcement_settings_text);
    $('#announcementSettingsConfirmModal').modal('show');
  }

  openBillingInformationSettingsConfirmModal() {
    $('#billingInformationSettingsConfirmModal').modal('show');
  }

  resetPaymentModalState(modal_id) {
    const modal = $(`#${modal_id}`)
    const containers = modal.find('.payment-info-container');
    if (containers.length > 1) {
      containers.first().removeClass('d-none');
      containers.not(':first').addClass('d-none');
    }

    modal.find('#payment-password-instruction').removeClass('d-none');
    modal.find('#wrong-password').addClass('d-none');
    modal.find('input[type="password"]').val('');
    modal.find('.btn-update').prop('disabled', true);

    $('#subscriptions_card_ids_will_be_deleted')?.val('[]');
    $('#subscriptions_default_card_id')?.val('');
    const _settled = (typeof gon !== 'undefined' && gon.current_subscription)
      && (gon.current_subscription.payment_method === 'bank'
          || gon.current_subscription.has_card
          || !!$('#subscription_credit_card_number').val()
          || this.hasCard);
    $('#subscriptions_payment_method')?.val(_settled ? (gon.current_subscription.payment_method || 'stripe') : '');
    $('#subscriptions_payment_term')?.val('');
    $('#plan_header_in_draft_mode')?.val('false');
    $('#plan_header_first_time_payment_method_flow')?.val('false');
  }

  _flowModalIds() {
    return ['changePlanModal','upgradePlanPaymentModal','changePlanAndPaymentTermModal','changePlanConfirmModal','changePaymentMethodModal','handleConfirmPaymentMethodModal','annualPaymentModal','monthlyPaymentModal','CreditCard','CreditCardConfirm','creditCardSelect','request-payment-to-paid-modal','card-change-success'];
  }

  _tidyBackdrops() {
    const open = $('.modal.show').length;
    if (open === 0) {
      $('.modal-backdrop').remove();
      $('body').removeClass('modal-open').css('padding-right', '');
    } else {
      $('body').addClass('modal-open');
      const b = $('.modal-backdrop');
      if (b.length === 0) $('<div class="modal-backdrop fade show"></div>').appendTo(document.body);
      else if (b.length > 1) b.slice(1).remove();
    }
  }

  showFlowModal(id) {
    const me = this;
    const others = this._flowModalIds().filter(m => m !== id && $('#' + m).hasClass('show'));
    if (others.length) this.flowStack.push(others[others.length - 1]);
    $('#' + id).modal('show');
    others.forEach(function(m) { me._navHiding[m] = true; $('#' + m).modal('hide'); });
    setTimeout(function() { me._tidyBackdrops(); }, 500);
  }

  backFlowModal() {
    const me = this;
    const prev = this.flowStack.pop();
    const shown = this._flowModalIds().filter(m => $('#' + m).hasClass('show'));
    if (prev) {
      $('#' + prev).modal('show');
      shown.forEach(function(m) { if (m !== prev) { me._navHiding[m] = true; $('#' + m).modal('hide'); } });
      setTimeout(function() { me._tidyBackdrops(); }, 500);
    } else {
      this.closeFlow();
    }
  }

  closeFlow() {
    const me = this;
    this.flowStack = [];
    $('.modal').modal('hide');
    setTimeout(function() { me._navHiding = {}; me._tidyBackdrops(); }, 500);
  }

  hideAllModals() {
    $('.modal').modal('hide');
  }
}
